// Auto-generated celestial visibility calendar
// Generated on: 2025-04-01 00:27:04

const VISIBILITY_CALENDAR = {
  "2025-04-02": {
    "north": "M86",
    "south": "NGC6541"
  },
  "2025-04-03": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M72"
  },
  "2025-04-04": {
    "north": "M12",
    "south": "NGC6240"
  },
  "2025-04-05": {
    "north": "M106",
    "south": "M3"
  },
  "2025-04-06": {
    "north": "M100",
    "south": "NGC6752"
  },
  "2025-04-07": {
    "north": "M4",
    "south": "M21"
  },
  "2025-04-08": {
    "north": "M26",
    "south": "M23"
  },
  "2025-04-09": {
    "north": "NGC6826",
    "south": "M26"
  },
  "2025-04-10": {
    "north": "M22",
    "south": "NGC4945"
  },
  "2025-04-11": {
    "north": "NGC5466",
    "south": "NGC5053"
  },
  "2025-04-12": {
    "north": "M53",
    "south": "M57"
  },
  "2025-04-13": {
    "north": "NGC6712",
    "south": "NGC5128"
  },
  "2025-04-14": {
    "north": "NGC7009",
    "south": "NGC6445"
  },
  "2025-04-15": {
    "north": "NGC6514",
    "south": "M7"
  },
  "2025-04-16": {
    "north": "M2",
    "south": "M17"
  },
  "2025-04-17": {
    "north": "M72",
    "south": "SMC"
  },
  "2025-04-18": {
    "north": "NGC5053",
    "south": "M14"
  },
  "2025-04-19": {
    "north": "NGC5897",
    "south": "NGC7814"
  },
  "2025-04-20": {
    "north": "NGC188",
    "south": "M9"
  },
  "2025-04-21": {
    "north": "M7",
    "south": "NGC6934"
  },
  "2025-04-22": {
    "north": "M6",
    "south": "NGC6723"
  },
  "2025-04-23": {
    "north": "M27",
    "south": "M6"
  },
  "2025-04-24": {
    "north": "STEPHANS_QUINTET",
    "south": "NGC6514"
  },
  "2025-04-25": {
    "north": "NGC6445",
    "south": "M10"
  },
  "2025-04-26": {
    "north": "M69",
    "south": "M4"
  },
  "2025-04-27": {
    "north": "M62",
    "south": "NGC362"
  },
  "2025-04-28": {
    "north": "NGC7000",
    "south": "M22"
  },
  "2025-04-29": {
    "north": "M5",
    "south": "NGC6366"
  },
  "2025-04-30": {
    "north": "M14",
    "south": "NGC6781"
  },
  "2025-05-01": {
    "north": "M55",
    "south": "M25"
  },
  "2025-05-02": {
    "north": "NGC6503",
    "south": "M5"
  },
  "2025-05-03": {
    "north": "NGC6366",
    "south": "NGC288"
  },
  "2025-05-04": {
    "north": "NGC6960",
    "south": "M15"
  },
  "2025-05-05": {
    "north": "NGC404",
    "south": "NGC6397"
  },
  "2025-05-06": {
    "north": "M80",
    "south": "NGC300"
  },
  "2025-05-07": {
    "north": "M21",
    "south": "M70"
  },
  "2025-05-08": {
    "north": "NGC7293",
    "south": "NGC6760"
  },
  "2025-05-09": {
    "north": "MARKARIANS_CHAIN",
    "south": "M62"
  },
  "2025-05-10": {
    "north": "NGC7380",
    "south": "M8"
  },
  "2025-05-11": {
    "north": "M19",
    "south": "NGC7293"
  },
  "2025-05-12": {
    "north": "M32",
    "south": "NGC604"
  },
  "2025-05-13": {
    "north": "M39",
    "south": "M12"
  },
  "2025-05-14": {
    "north": "NGC6819",
    "south": "M30"
  },
  "2025-05-15": {
    "north": "M33",
    "south": "NGC6369"
  },
  "2025-05-16": {
    "north": "NGC288",
    "south": "M19"
  },
  "2025-05-17": {
    "north": "M76",
    "south": "NGC6960"
  },
  "2025-05-18": {
    "north": "M30",
    "south": "NGC6164"
  },
  "2025-05-19": {
    "north": "STEPHANS_QUINTET",
    "south": "NGC5897"
  },
  "2025-05-20": {
    "north": "NGC6934",
    "south": "M16"
  },
  "2025-05-21": {
    "north": "M107",
    "south": "M33"
  },
  "2025-05-22": {
    "north": "M28",
    "south": "NGC6188"
  },
  "2025-05-23": {
    "north": "NGC869",
    "south": "M20"
  },
  "2025-05-24": {
    "north": "NGC884",
    "south": "M28"
  },
  "2025-05-25": {
    "north": "IC1805",
    "south": "NGC6302"
  },
  "2025-05-26": {
    "north": "M13",
    "south": "NGC104"
  },
  "2025-05-27": {
    "north": "NGC6369",
    "south": "NGC6712"
  },
  "2025-05-28": {
    "north": "M103",
    "south": "NGC6334"
  },
  "2025-05-29": {
    "north": "M77",
    "south": "M75"
  },
  "2025-05-30": {
    "north": "SH2-136",
    "south": "M55"
  },
  "2025-05-31": {
    "north": "M70",
    "south": "M56"
  },
  "2025-06-01": {
    "north": "M23",
    "south": "M74"
  },
  "2025-06-02": {
    "north": "M92",
    "south": "M71"
  },
  "2025-06-03": {
    "north": "M8",
    "south": "NGC6559"
  },
  "2025-06-04": {
    "north": "NGC6229",
    "south": "M27"
  },
  "2025-06-05": {
    "north": "NGC7635",
    "south": "NGC7009"
  },
  "2025-06-06": {
    "north": "NGC457",
    "south": "M69"
  },
  "2025-06-07": {
    "north": "M9",
    "south": "NGC1073"
  },
  "2025-06-08": {
    "north": "M24",
    "south": "M2"
  },
  "2025-06-09": {
    "north": "M29",
    "south": "M107"
  },
  "2025-06-10": {
    "north": "NGC281",
    "south": "M11"
  },
  "2025-06-11": {
    "north": "NGC1499",
    "south": "NGC6231"
  },
  "2025-06-12": {
    "north": "NGC1275",
    "south": "M45"
  },
  "2025-06-13": {
    "north": "M71",
    "south": "NGC7331"
  },
  "2025-06-14": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M77"
  },
  "2025-06-15": {
    "north": "NGC604",
    "south": "M27"
  },
  "2025-06-16": {
    "north": "M20",
    "south": "M71"
  },
  "2025-06-17": {
    "north": "M34",
    "south": "M30"
  },
  "2025-06-18": {
    "north": "NGC7023",
    "south": "NGC7009"
  },
  "2025-06-19": {
    "north": "M15",
    "south": "M8"
  },
  "2025-06-20": {
    "north": "M56",
    "south": "NGC6960"
  },
  "2025-06-21": {
    "north": "M57",
    "south": "NGC6752"
  },
  "2025-06-22": {
    "north": "M11",
    "south": "M24"
  },
  "2025-06-23": {
    "north": "NGC1073",
    "south": "M74"
  },
  "2025-06-24": {
    "north": "NGC6543",
    "south": "NGC362"
  },
  "2025-06-25": {
    "north": "M38",
    "south": "M14"
  },
  "2025-06-26": {
    "north": "NGC6781",
    "south": "NGC300"
  },
  "2025-06-27": {
    "north": "NGC891",
    "south": "NGC6760"
  },
  "2025-06-28": {
    "north": "NGC7027",
    "south": "NGC7814"
  },
  "2025-06-29": {
    "north": "IC342",
    "south": "M79"
  },
  "2025-06-30": {
    "north": "NGC6760",
    "south": "NGC604"
  },
  "2025-07-01": {
    "north": "M110",
    "south": "M45"
  },
  "2025-07-02": {
    "north": "M75",
    "south": "M26"
  },
  "2025-07-03": {
    "north": "NGC1952",
    "south": "M1"
  },
  "2025-07-04": {
    "north": "M42",
    "south": "NGC288"
  },
  "2025-07-05": {
    "north": "M31",
    "south": "M37"
  },
  "2025-07-06": {
    "north": "M74",
    "south": "NGC2169"
  },
  "2025-07-07": {
    "north": "M36",
    "south": "NGC7331"
  },
  "2025-07-08": {
    "north": "M1",
    "south": "NGC6712"
  },
  "2025-07-09": {
    "north": "NGC2169",
    "south": "NGC2070"
  },
  "2025-07-10": {
    "north": "NGC7662",
    "south": "M57"
  },
  "2025-07-11": {
    "north": "M79",
    "south": "M75"
  },
  "2025-07-12": {
    "north": "M35",
    "south": "M55"
  },
  "2025-07-13": {
    "north": "NGC2237",
    "south": "NGC1851"
  },
  "2025-07-14": {
    "north": "NGC2264",
    "south": "M35"
  },
  "2025-07-15": {
    "north": "M41",
    "south": "NGC6723"
  },
  "2025-07-16": {
    "north": "M45",
    "south": "NGC1952"
  },
  "2025-07-17": {
    "north": "NGC2301",
    "south": "M56"
  },
  "2025-07-18": {
    "north": "M50",
    "south": "NGC1073"
  },
  "2025-07-19": {
    "north": "M78",
    "south": "M33"
  },
  "2025-07-20": {
    "north": "NGC7331",
    "south": "M42"
  },
  "2025-07-21": {
    "north": "NGC1931",
    "south": "M72"
  },
  "2025-07-22": {
    "north": "NGC2261",
    "south": "NGC2301"
  },
  "2025-07-23": {
    "north": "NGC2359",
    "south": "M36"
  },
  "2025-07-24": {
    "north": "NGC2362",
    "south": "SMC"
  },
  "2025-07-25": {
    "north": "NGC2392",
    "south": "NGC2359"
  },
  "2025-07-26": {
    "north": "M37",
    "south": "M50"
  },
  "2025-07-27": {
    "north": "NGC2419",
    "south": "M15"
  },
  "2025-07-28": {
    "north": "NGC2440",
    "south": "M78"
  },
  "2025-07-29": {
    "north": "M47",
    "south": "NGC2440"
  },
  "2025-07-30": {
    "north": "M46",
    "south": "NGC2451"
  },
  "2025-07-31": {
    "north": "NGC2438",
    "south": "NGC2362"
  },
  "2025-08-01": {
    "north": "NGC2403",
    "south": "NGC2392"
  },
  "2025-08-02": {
    "north": "M93",
    "south": "NGC2477"
  },
  "2025-08-03": {
    "north": "NGC1952",
    "south": "M93"
  },
  "2025-08-04": {
    "north": "NGC6888",
    "south": "NGC2264"
  },
  "2025-08-05": {
    "north": "NGC7000",
    "south": "NGC104"
  },
  "2025-08-06": {
    "north": "M103",
    "south": "NGC1931"
  },
  "2025-08-07": {
    "north": "NGC1073",
    "south": "M77"
  },
  "2025-08-08": {
    "north": "SH2-136",
    "south": "NGC2516"
  },
  "2025-08-09": {
    "north": "NGC7380",
    "south": "NGC2237"
  },
  "2025-08-10": {
    "north": "M48",
    "south": "M2"
  },
  "2025-08-11": {
    "north": "NGC7293",
    "south": "M47"
  },
  "2025-08-12": {
    "north": "NGC2392",
    "south": "NGC7293"
  },
  "2025-08-13": {
    "north": "M34",
    "south": "M41"
  },
  "2025-08-14": {
    "north": "NGC869",
    "south": "NGC2261"
  },
  "2025-08-15": {
    "north": "M42",
    "south": "LMC"
  },
  "2025-08-16": {
    "north": "NGC2359",
    "south": "IC2391"
  },
  "2025-08-17": {
    "north": "STEPHANS_QUINTET",
    "south": "M46"
  },
  "2025-08-18": {
    "north": "M1",
    "south": "M44"
  },
  "2025-08-19": {
    "north": "NGC1275",
    "south": "M48"
  },
  "2025-08-20": {
    "north": "NGC7662",
    "south": "NGC2438"
  },
  "2025-08-21": {
    "north": "NGC604",
    "south": "M67"
  },
  "2025-08-22": {
    "north": "M38",
    "south": "NGC2683"
  },
  "2025-08-23": {
    "north": "NGC457",
    "south": "NGC2359"
  },
  "2025-08-24": {
    "north": "M46",
    "south": "M36"
  },
  "2025-08-25": {
    "north": "M77",
    "south": "M67"
  },
  "2025-08-26": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M79"
  },
  "2025-08-27": {
    "north": "NGC404",
    "south": "NGC2516"
  },
  "2025-08-28": {
    "north": "IC342",
    "south": "M50"
  },
  "2025-08-29": {
    "north": "M45",
    "south": "NGC604"
  },
  "2025-08-30": {
    "north": "NGC2362",
    "south": "NGC288"
  },
  "2025-08-31": {
    "north": "NGC7635",
    "south": "NGC7331"
  },
  "2025-09-01": {
    "north": "IC1805",
    "south": "NGC1931"
  },
  "2025-09-02": {
    "north": "M78",
    "south": "NGC2264"
  },
  "2025-09-03": {
    "north": "M93",
    "south": "M44"
  },
  "2025-09-04": {
    "north": "NGC884",
    "south": "NGC7814"
  },
  "2025-09-05": {
    "north": "M32",
    "south": "M1"
  },
  "2025-09-06": {
    "north": "NGC2301",
    "south": "M74"
  },
  "2025-09-07": {
    "north": "M76",
    "south": "NGC2683"
  },
  "2025-09-08": {
    "north": "M44",
    "south": "NGC2301"
  },
  "2025-09-09": {
    "north": "IC2574",
    "south": "NGC3132"
  },
  "2025-09-10": {
    "north": "NGC288",
    "south": "LMC"
  },
  "2025-09-11": {
    "north": "M47",
    "south": "M48"
  },
  "2025-09-12": {
    "north": "M82",
    "south": "M37"
  },
  "2025-09-13": {
    "north": "NGC2440",
    "south": "M47"
  },
  "2025-09-14": {
    "north": "NGC752",
    "south": "M105"
  },
  "2025-09-15": {
    "north": "NGC2841",
    "south": "M93"
  },
  "2025-09-16": {
    "north": "NGC2419",
    "south": "NGC2169"
  },
  "2025-09-17": {
    "north": "M110",
    "south": "M96"
  },
  "2025-09-18": {
    "north": "M41",
    "south": "SMC"
  },
  "2025-09-19": {
    "north": "NGC1931",
    "south": "M46"
  },
  "2025-09-20": {
    "north": "M37",
    "south": "M33"
  },
  "2025-09-21": {
    "north": "NGC2237",
    "south": "NGC3603"
  },
  "2025-09-22": {
    "north": "M50",
    "south": "NGC2440"
  },
  "2025-09-23": {
    "north": "M97",
    "south": "NGC2261"
  },
  "2025-09-24": {
    "north": "M108",
    "south": "NGC3372"
  },
  "2025-09-25": {
    "north": "NGC3184",
    "south": "M77"
  },
  "2025-09-26": {
    "north": "NGC3521",
    "south": "NGC2477"
  },
  "2025-09-27": {
    "north": "M31",
    "south": "NGC3628"
  },
  "2025-09-28": {
    "north": "NGC2264",
    "south": "NGC362"
  },
  "2025-09-29": {
    "north": "M95",
    "south": "NGC3766"
  },
  "2025-09-30": {
    "north": "M79",
    "south": "NGC2362"
  },
  "2025-10-01": {
    "north": "NGC3310",
    "south": "M78"
  },
  "2025-10-02": {
    "north": "M66",
    "south": "NGC2451"
  },
  "2025-10-03": {
    "north": "M74",
    "south": "NGC104"
  },
  "2025-10-04": {
    "north": "NGC2261",
    "south": "IC2602"
  },
  "2025-10-05": {
    "north": "NGC891",
    "south": "NGC3576"
  },
  "2025-10-06": {
    "north": "NGC2683",
    "south": "M35"
  },
  "2025-10-07": {
    "north": "NGC4147",
    "south": "NGC300"
  },
  "2025-10-08": {
    "north": "M81",
    "south": "M100"
  },
  "2025-10-09": {
    "north": "VIRGO_SUPERCLUSTER",
    "south": "NGC4039"
  },
  "2025-10-10": {
    "north": "M100",
    "south": "NGC3521"
  },
  "2025-10-11": {
    "north": "M85",
    "south": "M49"
  },
  "2025-10-12": {
    "north": "M65",
    "south": "M68"
  },
  "2025-10-13": {
    "north": "NGC4038",
    "south": "IC2391"
  },
  "2025-10-14": {
    "north": "M84",
    "south": "NGC1952"
  },
  "2025-10-15": {
    "north": "M109",
    "south": "M60"
  },
  "2025-10-16": {
    "north": "NGC2169",
    "south": "NGC1851"
  },
  "2025-10-17": {
    "north": "M86",
    "south": "M89"
  },
  "2025-10-18": {
    "north": "NGC4039",
    "south": "M90"
  },
  "2025-10-19": {
    "north": "M33",
    "south": "M104"
  },
  "2025-10-20": {
    "north": "NGC4244",
    "south": "M53"
  },
  "2025-10-21": {
    "north": "NGC5053",
    "south": "M95"
  },
  "2025-10-22": {
    "north": "M63",
    "south": "M59"
  },
  "2025-10-23": {
    "north": "M59",
    "south": "M99"
  },
  "2025-10-24": {
    "north": "NGC4631",
    "south": "M66"
  },
  "2025-10-25": {
    "north": "NGC2438",
    "south": "M85"
  },
  "2025-10-26": {
    "north": "M51",
    "south": "NGC4565"
  },
  "2025-10-27": {
    "north": "NGC3628",
    "south": "NGC4631"
  },
  "2025-10-28": {
    "north": "M3",
    "south": "VIRGO_SUPERCLUSTER"
  },
  "2025-10-29": {
    "north": "M99",
    "south": "NGC4038"
  },
  "2025-10-30": {
    "north": "M35",
    "south": "NGC4147"
  },
  "2025-10-31": {
    "north": "M36",
    "south": "NGC2070"
  },
  "2025-11-01": {
    "north": "M105",
    "south": "NGC4725"
  },
  "2025-11-02": {
    "north": "M64",
    "south": "M45"
  },
  "2025-11-03": {
    "north": "NGC4565",
    "south": "NGC2237"
  },
  "2025-11-04": {
    "north": "NGC4656",
    "south": "M65"
  },
  "2025-11-05": {
    "north": "NGC1499",
    "south": "NGC4755"
  },
  "2025-11-06": {
    "north": "M89",
    "south": "NGC5466"
  },
  "2025-11-07": {
    "north": "NGC4449",
    "south": "NGC4945"
  },
  "2025-11-08": {
    "north": "NGC5466",
    "south": "M42"
  },
  "2025-11-09": {
    "north": "M101",
    "south": "M41"
  },
  "2025-11-10": {
    "north": "M68",
    "south": "NGC5128"
  },
  "2025-11-11": {
    "north": "M90",
    "south": "NGC5139"
  },
  "2025-11-12": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M3"
  },
  "2025-11-13": {
    "north": "NGC5746",
    "south": "M84"
  },
  "2025-11-14": {
    "north": "NGC4725",
    "south": "NGC3532"
  },
  "2025-11-15": {
    "north": "M60",
    "south": "M64"
  },
  "2025-11-16": {
    "north": "M67",
    "south": "NGC2392"
  },
  "2025-11-17": {
    "north": "M53",
    "south": "NGC5053"
  },
  "2025-11-18": {
    "north": "M104",
    "south": "NGC5746"
  },
  "2025-11-19": {
    "north": "M83",
    "south": "NGC2438"
  },
  "2025-11-20": {
    "north": "M61",
    "south": "NGC3293"
  },
  "2025-11-21": {
    "north": "M106",
    "south": "M5"
  },
  "2025-11-22": {
    "north": "M94",
    "south": "M83"
  },
  "2025-11-23": {
    "north": "M102",
    "south": "NGC5897"
  },
  "2025-11-24": {
    "north": "M87",
    "south": "NGC5822"
  },
  "2025-11-25": {
    "north": "NGC5897",
    "south": "M86"
  },
  "2025-11-26": {
    "north": "M91",
    "south": "M61"
  },
  "2025-11-27": {
    "north": "M5",
    "south": "M91"
  },
  "2025-11-28": {
    "north": "M49",
    "south": "NGC4656"
  },
  "2025-11-29": {
    "north": "NGC4725",
    "south": "M87"
  },
  "2025-11-30": {
    "north": "M91",
    "south": "NGC5466"
  },
  "2025-12-01": {
    "north": "M81",
    "south": "M95"
  },
  "2025-12-02": {
    "north": "M44",
    "south": "NGC1851"
  },
  "2025-12-03": {
    "north": "M89",
    "south": "M100"
  },
  "2025-12-04": {
    "north": "NGC2403",
    "south": "M79"
  },
  "2025-12-05": {
    "north": "M42",
    "south": "NGC4945"
  },
  "2025-12-06": {
    "north": "M48",
    "south": "M80"
  },
  "2025-12-07": {
    "north": "M61",
    "south": "NGC2438"
  },
  "2025-12-08": {
    "north": "NGC4038",
    "south": "M48"
  },
  "2025-12-09": {
    "north": "M102",
    "south": "M47"
  },
  "2025-12-10": {
    "north": "M83",
    "south": "NGC2477"
  },
  "2025-12-11": {
    "north": "M94",
    "south": "M5"
  },
  "2025-12-12": {
    "north": "M46",
    "south": "M59"
  },
  "2025-12-13": {
    "north": "NGC4244",
    "south": "NGC5053"
  },
  "2025-12-14": {
    "north": "M41",
    "south": "M78"
  },
  "2025-12-15": {
    "north": "NGC2841",
    "south": "M90"
  },
  "2025-12-16": {
    "north": "M37",
    "south": "M99"
  },
  "2025-12-17": {
    "north": "NGC1952",
    "south": "M3"
  },
  "2025-12-18": {
    "north": "NGC2359",
    "south": "M96"
  },
  "2025-12-19": {
    "north": "M78",
    "south": "M84"
  },
  "2025-12-20": {
    "north": "NGC3184",
    "south": "NGC2359"
  },
  "2025-12-21": {
    "north": "M4",
    "south": "M87"
  },
  "2025-12-22": {
    "north": "M85",
    "south": "M67"
  },
  "2025-12-23": {
    "north": "M1",
    "south": "M12"
  },
  "2025-12-24": {
    "north": "NGC2362",
    "south": "NGC2169"
  },
  "2025-12-25": {
    "north": "M67",
    "south": "NGC6240"
  },
  "2025-12-26": {
    "north": "NGC2264",
    "south": "M65"
  },
  "2025-12-27": {
    "north": "M6",
    "south": "IC2391"
  },
  "2025-12-28": {
    "north": "IC2574",
    "south": "M93"
  },
  "2025-12-29": {
    "north": "NGC4656",
    "south": "NGC3532"
  },
  "2025-12-30": {
    "north": "M99",
    "south": "M68"
  },
  "2025-12-31": {
    "north": "M10",
    "south": "M105"
  },
  "2026-01-01": {
    "north": "NGC5746",
    "south": "M23"
  },
  "2026-01-02": {
    "north": "M105",
    "south": "M6"
  },
  "2026-01-03": {
    "north": "M51",
    "south": "NGC6514"
  },
  "2026-01-04": {
    "north": "NGC6240",
    "south": "NGC6302"
  },
  "2026-01-05": {
    "north": "M66",
    "south": "NGC3576"
  },
  "2026-01-06": {
    "north": "NGC6366",
    "south": "M85"
  },
  "2026-01-07": {
    "north": "NGC2683",
    "south": "NGC3521"
  },
  "2026-01-08": {
    "north": "M69",
    "south": "NGC2261"
  },
  "2026-01-09": {
    "north": "NGC4147",
    "south": "NGC3132"
  },
  "2026-01-10": {
    "north": "M8",
    "south": "M50"
  },
  "2026-01-11": {
    "north": "NGC6559",
    "south": "M16"
  },
  "2026-01-12": {
    "north": "M50",
    "south": "NGC5139"
  },
  "2026-01-13": {
    "north": "M70",
    "south": "M4"
  },
  "2026-01-14": {
    "north": "NGC6712",
    "south": "NGC4755"
  },
  "2026-01-15": {
    "north": "M101",
    "south": "NGC6712"
  },
  "2026-01-16": {
    "north": "M12",
    "south": "M17"
  },
  "2026-01-17": {
    "north": "M109",
    "south": "M66"
  },
  "2026-01-18": {
    "north": "M57",
    "south": "M104"
  },
  "2026-01-19": {
    "north": "M90",
    "south": "NGC3372"
  },
  "2026-01-20": {
    "north": "NGC6543",
    "south": "VIRGO_SUPERCLUSTER"
  },
  "2026-01-21": {
    "north": "M49",
    "south": "NGC2392"
  },
  "2026-01-22": {
    "north": "M97",
    "south": "M70"
  },
  "2026-01-23": {
    "north": "NGC4631",
    "south": "M83"
  },
  "2026-01-24": {
    "north": "NGC6781",
    "south": "M24"
  },
  "2026-01-25": {
    "north": "NGC6514",
    "south": "NGC6723"
  },
  "2026-01-26": {
    "north": "NGC6819",
    "south": "M10"
  },
  "2026-01-27": {
    "north": "M106",
    "south": "M21"
  },
  "2026-01-28": {
    "north": "M92",
    "south": "NGC4656"
  },
  "2026-01-29": {
    "north": "VIRGO_SUPERCLUSTER",
    "south": "NGC4725"
  },
  "2026-01-30": {
    "north": "NGC4565",
    "south": "NGC6397"
  },
  "2026-01-31": {
    "north": "M95",
    "south": "M49"
  },
  "2026-02-01": {
    "north": "NGC3628",
    "south": "NGC6369"
  },
  "2026-02-02": {
    "north": "NGC3310",
    "south": "NGC6445"
  },
  "2026-02-03": {
    "north": "NGC6826",
    "south": "NGC6559"
  },
  "2026-02-04": {
    "north": "M60",
    "south": "NGC6231"
  },
  "2026-02-05": {
    "north": "M25",
    "south": "M9"
  },
  "2026-02-06": {
    "north": "M9",
    "south": "M11"
  },
  "2026-02-07": {
    "north": "NGC5053",
    "south": "NGC4631"
  },
  "2026-02-08": {
    "north": "M17",
    "south": "M25"
  },
  "2026-02-09": {
    "north": "M22",
    "south": "NGC3293"
  },
  "2026-02-10": {
    "north": "M107",
    "south": "NGC6934"
  },
  "2026-02-11": {
    "north": "M27",
    "south": "M22"
  },
  "2026-02-12": {
    "north": "M3",
    "south": "NGC6164"
  },
  "2026-02-13": {
    "north": "M5",
    "south": "NGC5822"
  },
  "2026-02-14": {
    "north": "NGC3521",
    "south": "NGC4147"
  },
  "2026-02-15": {
    "north": "M75",
    "south": "M60"
  },
  "2026-02-16": {
    "north": "M28",
    "south": "NGC4038"
  },
  "2026-02-17": {
    "north": "M62",
    "south": "M56"
  },
  "2026-02-18": {
    "north": "M87",
    "south": "M71"
  },
  "2026-02-19": {
    "north": "M86",
    "south": "M55"
  },
  "2026-02-20": {
    "north": "NGC6369",
    "south": "NGC6752"
  },
  "2026-02-21": {
    "north": "M71",
    "south": "M91"
  },
  "2026-02-22": {
    "north": "NGC6445",
    "south": "M53"
  },
  "2026-02-23": {
    "north": "M104",
    "south": "M64"
  },
  "2026-02-24": {
    "north": "M65",
    "south": "M15"
  },
  "2026-02-25": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M61"
  },
  "2026-02-26": {
    "north": "M29",
    "south": "M75"
  },
  "2026-02-27": {
    "north": "M13",
    "south": "M26"
  },
  "2026-02-28": {
    "north": "M14",
    "south": "M62"
  },
  "2026-03-01": {
    "north": "NGC4449",
    "south": "M89"
  },
  "2026-03-02": {
    "north": "M21",
    "south": "IC2602"
  },
  "2026-03-03": {
    "north": "NGC7009",
    "south": "M30"
  },
  "2026-03-04": {
    "north": "M72",
    "south": "NGC3766"
  },
  "2026-03-05": {
    "north": "M84",
    "south": "M19"
  },
  "2026-03-06": {
    "north": "M30",
    "south": "NGC3628"
  },
  "2026-03-07": {
    "north": "NGC5466",
    "south": "M107"
  },
  "2026-03-08": {
    "north": "M55",
    "south": "NGC5746"
  },
  "2026-03-09": {
    "north": "NGC6888",
    "south": "NGC6760"
  },
  "2026-03-10": {
    "north": "M64",
    "south": "NGC6960"
  },
  "2026-03-11": {
    "north": "M2",
    "south": "NGC6188"
  },
  "2026-03-12": {
    "north": "NGC6229",
    "south": "NGC4039"
  },
  "2026-03-13": {
    "north": "M53",
    "south": "M69"
  },
  "2026-03-14": {
    "north": "M24",
    "south": "M72"
  },
  "2026-03-15": {
    "north": "M100",
    "south": "M7"
  },
  "2026-03-16": {
    "north": "NGC6934",
    "south": "M14"
  },
  "2026-03-17": {
    "north": "M7",
    "south": "NGC6334"
  },
  "2026-03-18": {
    "north": "NGC6760",
    "south": "M27"
  },
  "2026-03-19": {
    "north": "NGC7023",
    "south": "NGC7009"
  },
  "2026-03-20": {
    "north": "NGC7331",
    "south": "M20"
  },
  "2026-03-21": {
    "north": "M26",
    "south": "NGC6366"
  },
  "2026-03-22": {
    "north": "NGC4039",
    "south": "M57"
  },
  "2026-03-23": {
    "north": "M11",
    "south": "M8"
  },
  "2026-03-24": {
    "north": "NGC7027",
    "south": "M86"
  },
  "2026-03-25": {
    "north": "M15",
    "south": "NGC5897"
  },
  "2026-03-26": {
    "north": "M80",
    "south": "M28"
  },
  "2026-03-27": {
    "north": "M23",
    "south": "NGC6541"
  },
  "2026-03-28": {
    "north": "NGC7635",
    "south": "NGC4565"
  },
  "2026-03-29": {
    "north": "NGC7000",
    "south": "NGC7293"
  },
  "2026-03-30": {
    "north": "NGC6503",
    "south": "M2"
  },
  "2026-03-31": {
    "north": "M20",
    "south": "NGC5128"
  },
  "2026-04-01": {
    "north": "NGC7293",
    "south": "NGC6781"
  },
  "2026-04-02": {
    "north": "M59",
    "south": "NGC7331"
  },
  "2026-04-03": {
    "north": "M52",
    "south": "NGC7814"
  },
  "2026-04-04": {
    "north": "M19",
    "south": "M84"
  },
  "2026-04-05": {
    "north": "NGC6960",
    "south": "M62"
  },
  "2026-04-06": {
    "north": "SH2-136",
    "south": "M72"
  },
  "2026-04-07": {
    "north": "M39",
    "south": "NGC7009"
  },
  "2026-04-08": {
    "north": "M63",
    "south": "NGC5053"
  },
  "2026-04-09": {
    "north": "M16",
    "south": "M57"
  },
  "2026-04-10": {
    "north": "STEPHANS_QUINTET",
    "south": "M6"
  },
  "2026-04-11": {
    "north": "NGC5897",
    "south": "M83"
  },
  "2026-04-12": {
    "north": "M56",
    "south": "NGC6302"
  },
  "2026-04-13": {
    "north": "NGC7380",
    "south": "NGC5746"
  },
  "2026-04-14": {
    "north": "NGC188",
    "south": "NGC6164"
  },
  "2026-04-15": {
    "north": "NGC281",
    "south": "NGC6231"
  },
  "2026-04-16": {
    "north": "NGC288",
    "south": "NGC6366"
  },
  "2026-04-17": {
    "north": "M31",
    "south": "M53"
  },
  "2026-04-18": {
    "north": "M32",
    "south": "M27"
  },
  "2026-04-19": {
    "north": "NGC7662",
    "south": "M23"
  },
  "2026-04-20": {
    "north": "M110",
    "south": "NGC6445"
  },
  "2026-04-21": {
    "north": "NGC404",
    "south": "NGC7814"
  },
  "2026-04-22": {
    "north": "NGC457",
    "south": "M55"
  },
  "2026-04-23": {
    "north": "M20",
    "south": "M22"
  },
  "2026-04-24": {
    "north": "M32",
    "south": "M9"
  },
  "2026-04-25": {
    "north": "M55",
    "south": "M11"
  },
  "2026-04-26": {
    "north": "NGC5897",
    "south": "M24"
  },
  "2026-04-27": {
    "north": "M107",
    "south": "NGC300"
  },
  "2026-04-28": {
    "north": "M27",
    "south": "NGC7293"
  },
  "2026-04-29": {
    "north": "M70",
    "south": "NGC604"
  },
  "2026-04-30": {
    "north": "M5",
    "south": "NGC6934"
  },
  "2026-05-01": {
    "north": "NGC6712",
    "south": "NGC6541"
  },
  "2026-05-02": {
    "north": "M72",
    "south": "NGC104"
  },
  "2026-05-03": {
    "north": "M25",
    "south": "NGC288"
  },
  "2026-05-04": {
    "north": "M62",
    "south": "M69"
  },
  "2026-05-05": {
    "north": "NGC188",
    "south": "M12"
  },
  "2026-05-06": {
    "north": "M80",
    "south": "NGC6397"
  },
  "2026-05-07": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M28"
  },
  "2026-05-08": {
    "north": "M76",
    "south": "M20"
  },
  "2026-05-09": {
    "north": "NGC6888",
    "south": "M107"
  },
  "2026-05-10": {
    "north": "NGC7635",
    "south": "M33"
  },
  "2026-05-11": {
    "north": "NGC6960",
    "south": "NGC6760"
  },
  "2026-05-12": {
    "north": "M22",
    "south": "NGC6240"
  },
  "2026-05-13": {
    "north": "M92",
    "south": "NGC1073"
  },
  "2026-05-14": {
    "north": "IC1805",
    "south": "M17"
  },
  "2026-05-15": {
    "north": "M16",
    "south": "M77"
  },
  "2026-05-16": {
    "north": "NGC6819",
    "south": "NGC6334"
  },
  "2026-05-17": {
    "north": "M21",
    "south": "M7"
  },
  "2026-05-18": {
    "north": "M19",
    "south": "NGC6369"
  },
  "2026-05-19": {
    "north": "M39",
    "south": "M8"
  },
  "2026-05-20": {
    "north": "NGC604",
    "south": "NGC6960"
  },
  "2026-05-21": {
    "north": "M14",
    "south": "M80"
  },
  "2026-05-22": {
    "north": "SH2-136",
    "south": "M74"
  },
  "2026-05-23": {
    "north": "NGC281",
    "south": "NGC6723"
  },
  "2026-05-24": {
    "north": "M17",
    "south": "NGC6752"
  },
  "2026-05-25": {
    "north": "NGC7293",
    "south": "M26"
  },
  "2026-05-26": {
    "north": "M31",
    "south": "M16"
  },
  "2026-05-27": {
    "north": "M13",
    "south": "SMC"
  },
  "2026-05-28": {
    "north": "NGC6229",
    "south": "NGC362"
  },
  "2026-05-29": {
    "north": "M7",
    "south": "M70"
  },
  "2026-05-30": {
    "north": "M33",
    "south": "M2"
  },
  "2026-05-31": {
    "north": "NGC6369",
    "south": "M4"
  },
  "2026-06-01": {
    "north": "STEPHANS_QUINTET",
    "south": "M56"
  },
  "2026-06-02": {
    "north": "M2",
    "south": "M21"
  },
  "2026-06-03": {
    "north": "MARKARIANS_CHAIN",
    "south": "NGC6781"
  },
  "2026-06-04": {
    "north": "NGC6366",
    "south": "M71"
  },
  "2026-06-05": {
    "north": "NGC891",
    "south": "M19"
  },
  "2026-06-06": {
    "north": "IC342",
    "south": "M75"
  },
  "2026-06-07": {
    "north": "M15",
    "south": "M45"
  },
  "2026-06-08": {
    "north": "M45",
    "south": "NGC6712"
  },
  "2026-06-09": {
    "north": "M74",
    "south": "NGC7331"
  },
  "2026-06-10": {
    "north": "M23",
    "south": "M25"
  },
  "2026-06-11": {
    "north": "NGC6543",
    "south": "M30"
  },
  "2026-06-12": {
    "north": "NGC6559",
    "south": "M14"
  },
  "2026-06-13": {
    "north": "NGC7331",
    "south": "M10"
  },
  "2026-06-14": {
    "north": "M103",
    "south": "NGC6559"
  },
  "2026-06-15": {
    "north": "NGC1073",
    "south": "M15"
  },
  "2026-06-16": {
    "north": "M69",
    "south": "NGC6514"
  },
  "2026-06-17": {
    "north": "M56",
    "south": "NGC7009"
  },
  "2026-06-18": {
    "north": "NGC7009",
    "south": "M45"
  },
  "2026-06-19": {
    "north": "M75",
    "south": "M20"
  },
  "2026-06-20": {
    "north": "NGC6514",
    "south": "M2"
  },
  "2026-06-21": {
    "north": "M11",
    "south": "NGC6559"
  },
  "2026-06-22": {
    "north": "M77",
    "south": "M21"
  },
  "2026-06-23": {
    "north": "M79",
    "south": "SMC"
  },
  "2026-06-24": {
    "north": "M34",
    "south": "M70"
  },
  "2026-06-25": {
    "north": "M30",
    "south": "NGC7814"
  },
  "2026-06-26": {
    "north": "NGC6503",
    "south": "NGC104"
  },
  "2026-06-27": {
    "north": "M8",
    "south": "NGC6934"
  },
  "2026-06-28": {
    "north": "NGC7662",
    "south": "M69"
  },
  "2026-06-29": {
    "north": "M36",
    "south": "M33"
  },
  "2026-06-30": {
    "north": "M71",
    "south": "M25"
  },
  "2026-07-01": {
    "north": "NGC404",
    "south": "NGC7331"
  },
  "2026-07-02": {
    "north": "NGC6781",
    "south": "M79"
  },
  "2026-07-03": {
    "north": "M1",
    "south": "NGC6781"
  },
  "2026-07-04": {
    "north": "NGC1499",
    "south": "M1"
  },
  "2026-07-05": {
    "north": "M57",
    "south": "M24"
  },
  "2026-07-06": {
    "north": "NGC457",
    "south": "NGC300"
  },
  "2026-07-07": {
    "north": "NGC884",
    "south": "NGC2070"
  },
  "2026-07-08": {
    "north": "M110",
    "south": "M27"
  },
  "2026-07-09": {
    "north": "NGC869",
    "south": "M30"
  },
  "2026-07-10": {
    "north": "NGC7380",
    "south": "NGC604"
  },
  "2026-07-11": {
    "north": "NGC6934",
    "south": "M26"
  },
  "2026-07-12": {
    "north": "NGC1275",
    "south": "NGC288"
  },
  "2026-07-13": {
    "north": "NGC7814",
    "south": "NGC1931"
  },
  "2026-07-14": {
    "north": "NGC1952",
    "south": "NGC7293"
  },
  "2026-07-15": {
    "north": "M29",
    "south": "M35"
  },
  "2026-07-16": {
    "north": "M35",
    "south": "NGC2264"
  },
  "2026-07-17": {
    "north": "NGC2261",
    "south": "M74"
  },
  "2026-07-18": {
    "north": "NGC2264",
    "south": "M55"
  },
  "2026-07-19": {
    "north": "M78",
    "south": "NGC2261"
  },
  "2026-07-20": {
    "north": "NGC7023",
    "south": "NGC2169"
  },
  "2026-07-21": {
    "north": "NGC2301",
    "south": "NGC2237"
  },
  "2026-07-22": {
    "north": "NGC288",
    "south": "M37"
  },
  "2026-07-23": {
    "north": "M52",
    "south": "M78"
  },
  "2026-07-24": {
    "north": "M41",
    "south": "NGC362"
  },
  "2026-07-25": {
    "north": "NGC2362",
    "south": "M50"
  },
  "2026-07-26": {
    "north": "NGC6826",
    "south": "NGC6960"
  },
  "2026-07-27": {
    "north": "M50",
    "south": "NGC2362"
  },
  "2026-07-28": {
    "north": "NGC2392",
    "south": "M75"
  },
  "2026-07-29": {
    "north": "M93",
    "south": "M77"
  },
  "2026-07-30": {
    "north": "NGC2403",
    "south": "NGC1952"
  },
  "2026-07-31": {
    "north": "M42",
    "south": "M93"
  },
  "2026-08-01": {
    "north": "NGC2169",
    "south": "NGC1073"
  },
  "2026-08-02": {
    "north": "M38",
    "south": "NGC2301"
  },
  "2026-08-03": {
    "north": "NGC2359",
    "south": "M15"
  },
  "2026-08-04": {
    "north": "M37",
    "south": "NGC2516"
  },
  "2026-08-05": {
    "north": "NGC2438",
    "south": "NGC2440"
  },
  "2026-08-06": {
    "north": "NGC1931",
    "south": "LMC"
  },
  "2026-08-07": {
    "north": "NGC2440",
    "south": "NGC2359"
  },
  "2026-08-08": {
    "north": "NGC2419",
    "south": "NGC2477"
  },
  "2026-08-09": {
    "north": "NGC2237",
    "south": "NGC2438"
  },
  "2026-08-10": {
    "north": "NGC7000",
    "south": "M41"
  },
  "2026-08-11": {
    "north": "M47",
    "south": "NGC1851"
  },
  "2026-08-12": {
    "north": "M46",
    "south": "M48"
  },
  "2026-08-13": {
    "north": "M44",
    "south": "M36"
  },
  "2026-08-14": {
    "north": "M48",
    "south": "M44"
  },
  "2026-08-15": {
    "north": "NGC2683",
    "south": "M67"
  },
  "2026-08-16": {
    "north": "M67",
    "south": "IC2391"
  },
  "2026-08-17": {
    "north": "NGC404",
    "south": "M47"
  },
  "2026-08-18": {
    "north": "NGC2169",
    "south": "NGC2451"
  },
  "2026-08-19": {
    "north": "M52",
    "south": "NGC2683"
  },
  "2026-08-20": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M46"
  },
  "2026-08-21": {
    "north": "M45",
    "south": "NGC2392"
  },
  "2026-08-22": {
    "north": "NGC2362",
    "south": "M42"
  },
  "2026-08-23": {
    "north": "M47",
    "south": "M35"
  },
  "2026-08-24": {
    "north": "M77",
    "south": "NGC2070"
  },
  "2026-08-25": {
    "north": "NGC7380",
    "south": "NGC1952"
  },
  "2026-08-26": {
    "north": "NGC7293",
    "south": "NGC2438"
  },
  "2026-08-27": {
    "north": "NGC2392",
    "south": "NGC2237"
  },
  "2026-08-28": {
    "north": "M67",
    "south": "NGC362"
  },
  "2026-08-29": {
    "north": "NGC2683",
    "south": "NGC2477"
  },
  "2026-08-30": {
    "north": "M103",
    "south": "M44"
  },
  "2026-08-31": {
    "north": "NGC2237",
    "south": "NGC1851"
  },
  "2026-09-01": {
    "north": "M110",
    "south": "NGC2169"
  },
  "2026-09-02": {
    "north": "NGC1499",
    "south": "M93"
  },
  "2026-09-03": {
    "north": "NGC2359",
    "south": "NGC104"
  },
  "2026-09-04": {
    "north": "NGC7331",
    "south": "NGC3132"
  },
  "2026-09-05": {
    "north": "NGC281",
    "south": "NGC2359"
  },
  "2026-09-06": {
    "north": "M35",
    "south": "NGC2392"
  },
  "2026-09-07": {
    "north": "NGC288",
    "south": "M46"
  },
  "2026-09-08": {
    "north": "M50",
    "south": "M47"
  },
  "2026-09-09": {
    "north": "M1",
    "south": "NGC1073"
  },
  "2026-09-10": {
    "north": "NGC7635",
    "south": "M1"
  },
  "2026-09-11": {
    "north": "M74",
    "south": "M36"
  },
  "2026-09-12": {
    "north": "NGC2261",
    "south": "LMC"
  },
  "2026-09-13": {
    "north": "NGC604",
    "south": "M37"
  },
  "2026-09-14": {
    "north": "NGC457",
    "south": "NGC2451"
  },
  "2026-09-15": {
    "north": "NGC7662",
    "south": "IC2391"
  },
  "2026-09-16": {
    "north": "NGC1073",
    "south": "SMC"
  },
  "2026-09-17": {
    "north": "NGC3184",
    "south": "IC2602"
  },
  "2026-09-18": {
    "north": "NGC2419",
    "south": "NGC2261"
  },
  "2026-09-19": {
    "north": "M81",
    "south": "M50"
  },
  "2026-09-20": {
    "north": "NGC2403",
    "south": "NGC604"
  },
  "2026-09-21": {
    "north": "M34",
    "south": "NGC3293"
  },
  "2026-09-22": {
    "north": "NGC7814",
    "south": "NGC3521"
  },
  "2026-09-23": {
    "north": "NGC2841",
    "south": "NGC1931"
  },
  "2026-09-24": {
    "north": "M42",
    "south": "NGC2362"
  },
  "2026-09-25": {
    "north": "M44",
    "south": "NGC2683"
  },
  "2026-09-26": {
    "north": "NGC3310",
    "south": "NGC3576"
  },
  "2026-09-27": {
    "north": "M79",
    "south": "NGC2301"
  },
  "2026-09-28": {
    "north": "M105",
    "south": "NGC3628"
  },
  "2026-09-29": {
    "north": "M96",
    "south": "M65"
  },
  "2026-09-30": {
    "north": "IC2574",
    "south": "NGC3372"
  },
  "2026-10-01": {
    "north": "NGC869",
    "south": "M42"
  },
  "2026-10-02": {
    "north": "M108",
    "south": "M74"
  },
  "2026-10-03": {
    "north": "NGC4038",
    "south": "NGC288"
  },
  "2026-10-04": {
    "north": "NGC4147",
    "south": "M78"
  },
  "2026-10-05": {
    "north": "NGC2438",
    "south": "NGC4038"
  },
  "2026-10-06": {
    "north": "M78",
    "south": "NGC2440"
  },
  "2026-10-07": {
    "north": "M61",
    "south": "M67"
  },
  "2026-10-08": {
    "north": "NGC752",
    "south": "M79"
  },
  "2026-10-09": {
    "north": "M38",
    "south": "M45"
  },
  "2026-10-10": {
    "north": "NGC188",
    "south": "NGC3766"
  },
  "2026-10-11": {
    "north": "M31",
    "south": "M77"
  },
  "2026-10-12": {
    "north": "VIRGO_SUPERCLUSTER",
    "south": "NGC3603"
  },
  "2026-10-13": {
    "north": "M37",
    "south": "NGC4565"
  },
  "2026-10-14": {
    "north": "NGC1952",
    "south": "M91"
  },
  "2026-10-15": {
    "north": "NGC4725",
    "south": "M84"
  },
  "2026-10-16": {
    "north": "M87",
    "south": "NGC4631"
  },
  "2026-10-17": {
    "north": "M109",
    "south": "NGC4039"
  },
  "2026-10-18": {
    "north": "NGC3521",
    "south": "M99"
  },
  "2026-10-19": {
    "north": "M99",
    "south": "M87"
  },
  "2026-10-20": {
    "north": "M104",
    "south": "M41"
  },
  "2026-10-21": {
    "north": "NGC884",
    "south": "M53"
  },
  "2026-10-22": {
    "north": "M63",
    "south": "NGC4656"
  },
  "2026-10-23": {
    "north": "NGC4565",
    "south": "M64"
  },
  "2026-10-24": {
    "north": "M66",
    "south": "M85"
  },
  "2026-10-25": {
    "north": "M97",
    "south": "NGC5128"
  },
  "2026-10-26": {
    "north": "M106",
    "south": "NGC4945"
  },
  "2026-10-27": {
    "north": "NGC5053",
    "south": "NGC2516"
  },
  "2026-10-28": {
    "north": "M84",
    "south": "M90"
  },
  "2026-10-29": {
    "north": "NGC4244",
    "south": "M48"
  },
  "2026-10-30": {
    "north": "IC1805",
    "south": "NGC4147"
  },
  "2026-10-31": {
    "north": "NGC891",
    "south": "NGC4725"
  },
  "2026-11-01": {
    "north": "M91",
    "south": "M66"
  },
  "2026-11-02": {
    "north": "M3",
    "south": "M89"
  },
  "2026-11-03": {
    "north": "M68",
    "south": "M3"
  },
  "2026-11-04": {
    "north": "M94",
    "south": "M86"
  },
  "2026-11-05": {
    "north": "NGC1275",
    "south": "M61"
  },
  "2026-11-06": {
    "north": "M89",
    "south": "M104"
  },
  "2026-11-07": {
    "north": "NGC4656",
    "south": "NGC3532"
  },
  "2026-11-08": {
    "north": "NGC4631",
    "south": "M60"
  },
  "2026-11-09": {
    "north": "M59",
    "south": "VIRGO_SUPERCLUSTER"
  },
  "2026-11-10": {
    "north": "NGC2264",
    "south": "M49"
  },
  "2026-11-11": {
    "north": "M82",
    "south": "NGC5139"
  },
  "2026-11-12": {
    "north": "M90",
    "south": "M105"
  },
  "2026-11-13": {
    "north": "M53",
    "south": "M59"
  },
  "2026-11-14": {
    "north": "M101",
    "south": "NGC4755"
  },
  "2026-11-15": {
    "north": "NGC5746",
    "south": "NGC5053"
  },
  "2026-11-16": {
    "north": "M93",
    "south": "M68"
  },
  "2026-11-17": {
    "north": "NGC3628",
    "south": "NGC5822"
  },
  "2026-11-18": {
    "north": "M41",
    "south": "M95"
  },
  "2026-11-19": {
    "north": "M102",
    "south": "NGC5746"
  },
  "2026-11-20": {
    "north": "M64",
    "south": "M83"
  },
  "2026-11-21": {
    "north": "NGC5897",
    "south": "M5"
  },
  "2026-11-22": {
    "north": "M83",
    "south": "NGC2264"
  },
  "2026-11-23": {
    "north": "M86",
    "south": "NGC5897"
  },
  "2026-11-24": {
    "north": "M85",
    "south": "M100"
  },
  "2026-11-25": {
    "north": "NGC1931",
    "south": "NGC5466"
  },
  "2026-11-26": {
    "north": "M51",
    "south": "M96"
  },
  "2026-11-27": {
    "north": "M100",
    "south": "M3"
  },
  "2026-11-28": {
    "north": "M46",
    "south": "NGC5128"
  },
  "2026-11-29": {
    "north": "NGC4039",
    "south": "M61"
  },
  "2026-11-30": {
    "north": "M48",
    "south": "NGC2392"
  },
  "2026-12-01": {
    "north": "NGC2440",
    "south": "M86"
  },
  "2026-12-02": {
    "north": "M65",
    "south": "M46"
  },
  "2026-12-03": {
    "north": "NGC4449",
    "south": "NGC1851"
  },
  "2026-12-04": {
    "north": "M95",
    "south": "M96"
  },
  "2026-12-05": {
    "north": "M49",
    "south": "NGC4147"
  },
  "2026-12-06": {
    "north": "M60",
    "south": "NGC4725"
  },
  "2026-12-07": {
    "north": "M80",
    "south": "NGC1931"
  },
  "2026-12-08": {
    "north": "M5",
    "south": "NGC4038"
  },
  "2026-12-09": {
    "north": "M36",
    "south": "M90"
  },
  "2026-12-10": {
    "north": "M107",
    "south": "NGC2362"
  },
  "2026-12-11": {
    "north": "NGC5466",
    "south": "NGC3576"
  },
  "2026-12-12": {
    "north": "M4",
    "south": "NGC5139"
  },
  "2026-12-13": {
    "north": "M12",
    "south": "M35"
  },
  "2026-12-14": {
    "north": "M13",
    "south": "M78"
  },
  "2026-12-15": {
    "north": "NGC6229",
    "south": "M49"
  },
  "2026-12-16": {
    "north": "M10",
    "south": "M85"
  },
  "2026-12-17": {
    "north": "M19",
    "south": "M65"
  },
  "2026-12-18": {
    "north": "NGC6240",
    "south": "NGC5053"
  },
  "2026-12-19": {
    "north": "M62",
    "south": "NGC5822"
  },
  "2026-12-20": {
    "north": "M37",
    "south": "M93"
  },
  "2026-12-21": {
    "north": "M80",
    "south": "NGC3132"
  },
  "2026-12-22": {
    "north": "M44",
    "south": "M36"
  },
  "2026-12-23": {
    "north": "M3",
    "south": "NGC3521"
  },
  "2026-12-24": {
    "north": "M51",
    "south": "NGC2477"
  },
  "2026-12-25": {
    "north": "NGC2440",
    "south": "M66"
  },
  "2026-12-26": {
    "north": "M82",
    "south": "M99"
  },
  "2026-12-27": {
    "north": "M85",
    "south": "M14"
  },
  "2026-12-28": {
    "north": "NGC2438",
    "south": "NGC5466"
  },
  "2026-12-29": {
    "north": "NGC5897",
    "south": "NGC2359"
  },
  "2026-12-30": {
    "north": "NGC4039",
    "south": "M80"
  },
  "2026-12-31": {
    "north": "NGC2841",
    "south": "NGC4039"
  },
  "2027-01-01": {
    "north": "NGC4244",
    "south": "NGC3532"
  },
  "2027-01-02": {
    "north": "NGC2419",
    "south": "NGC2683"
  },
  "2027-01-03": {
    "north": "M100",
    "south": "M91"
  },
  "2027-01-04": {
    "north": "M60",
    "south": "NGC4631"
  },
  "2027-01-05": {
    "north": "M91",
    "south": "IC2391"
  },
  "2027-01-06": {
    "north": "M94",
    "south": "M6"
  },
  "2027-01-07": {
    "north": "M13",
    "south": "NGC3628"
  },
  "2027-01-08": {
    "north": "M50",
    "south": "M16"
  },
  "2027-01-09": {
    "north": "NGC6445",
    "south": "M12"
  },
  "2027-01-10": {
    "north": "M5",
    "south": "M69"
  },
  "2027-01-11": {
    "north": "M48",
    "south": "M4"
  },
  "2027-01-12": {
    "north": "M22",
    "south": "M28"
  },
  "2027-01-13": {
    "north": "NGC5466",
    "south": "M53"
  },
  "2027-01-14": {
    "north": "M106",
    "south": "M67"
  },
  "2027-01-15": {
    "north": "M8",
    "south": "M60"
  },
  "2027-01-16": {
    "north": "NGC6240",
    "south": "M105"
  },
  "2027-01-17": {
    "north": "M17",
    "south": "IC2602"
  },
  "2027-01-18": {
    "north": "M99",
    "south": "NGC6240"
  },
  "2027-01-19": {
    "north": "M9",
    "south": "M7"
  },
  "2027-01-20": {
    "north": "M83",
    "south": "M107"
  },
  "2027-01-21": {
    "north": "NGC3521",
    "south": "NGC4565"
  },
  "2027-01-22": {
    "north": "NGC6781",
    "south": "NGC5746"
  },
  "2027-01-23": {
    "north": "M12",
    "south": "NGC4755"
  },
  "2027-01-24": {
    "north": "NGC5746",
    "south": "M10"
  },
  "2027-01-25": {
    "north": "M65",
    "south": "M17"
  },
  "2027-01-26": {
    "north": "M11",
    "south": "M56"
  },
  "2027-01-27": {
    "north": "M56",
    "south": "NGC5897"
  },
  "2027-01-28": {
    "north": "M84",
    "south": "M26"
  },
  "2027-01-29": {
    "north": "M67",
    "south": "NGC3603"
  },
  "2027-01-30": {
    "north": "NGC6712",
    "south": "M71"
  },
  "2027-01-31": {
    "north": "M28",
    "south": "M25"
  },
  "2027-02-01": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M23"
  },
  "2027-02-02": {
    "north": "NGC6826",
    "south": "M5"
  },
  "2027-02-03": {
    "north": "M101",
    "south": "M11"
  },
  "2027-02-04": {
    "north": "M64",
    "south": "NGC6397"
  },
  "2027-02-05": {
    "north": "M105",
    "south": "NGC6188"
  },
  "2027-02-06": {
    "north": "NGC6366",
    "south": "M57"
  },
  "2027-02-07": {
    "north": "M20",
    "south": "NGC3766"
  },
  "2027-02-08": {
    "north": "NGC3628",
    "south": "NGC4945"
  },
  "2027-02-09": {
    "north": "M92",
    "south": "NGC6934"
  },
  "2027-02-10": {
    "north": "M70",
    "south": "NGC6781"
  },
  "2027-02-11": {
    "north": "M59",
    "south": "NGC6164"
  },
  "2027-02-12": {
    "north": "M63",
    "south": "NGC6302"
  },
  "2027-02-13": {
    "north": "M86",
    "south": "M59"
  },
  "2027-02-14": {
    "north": "M55",
    "south": "NGC6760"
  },
  "2027-02-15": {
    "north": "M107",
    "south": "M84"
  },
  "2027-02-16": {
    "north": "M96",
    "south": "M83"
  },
  "2027-02-17": {
    "north": "VIRGO_SUPERCLUSTER",
    "south": "M24"
  },
  "2027-02-18": {
    "north": "NGC6819",
    "south": "M75"
  },
  "2027-02-19": {
    "north": "M89",
    "south": "NGC6541"
  },
  "2027-02-20": {
    "north": "NGC4449",
    "south": "NGC6366"
  },
  "2027-02-21": {
    "north": "NGC6369",
    "south": "M100"
  },
  "2027-02-22": {
    "north": "M69",
    "south": "M27"
  },
  "2027-02-23": {
    "north": "NGC3184",
    "south": "M70"
  },
  "2027-02-24": {
    "north": "M15",
    "south": "NGC3372"
  },
  "2027-02-25": {
    "north": "M95",
    "south": "NGC6334"
  },
  "2027-02-26": {
    "north": "M10",
    "south": "M55"
  },
  "2027-02-27": {
    "north": "M97",
    "south": "M62"
  },
  "2027-02-28": {
    "north": "NGC6760",
    "south": "NGC4656"
  },
  "2027-03-01": {
    "north": "M24",
    "south": "M87"
  },
  "2027-03-02": {
    "north": "M6",
    "south": "M20"
  },
  "2027-03-03": {
    "north": "M29",
    "south": "NGC6445"
  },
  "2027-03-04": {
    "north": "M23",
    "south": "M21"
  },
  "2027-03-05": {
    "north": "NGC7027",
    "south": "M8"
  },
  "2027-03-06": {
    "north": "NGC6888",
    "south": "M30"
  },
  "2027-03-07": {
    "north": "M71",
    "south": "NGC6559"
  },
  "2027-03-08": {
    "north": "NGC6543",
    "south": "M19"
  },
  "2027-03-09": {
    "north": "NGC6229",
    "south": "M64"
  },
  "2027-03-10": {
    "north": "M61",
    "south": "M95"
  },
  "2027-03-11": {
    "north": "NGC6503",
    "south": "VIRGO_SUPERCLUSTER"
  },
  "2027-03-12": {
    "north": "M75",
    "south": "M2"
  },
  "2027-03-13": {
    "north": "M7",
    "south": "M104"
  },
  "2027-03-14": {
    "north": "M108",
    "south": "NGC7293"
  },
  "2027-03-15": {
    "north": "M57",
    "south": "NGC6369"
  },
  "2027-03-16": {
    "north": "M102",
    "south": "M72"
  },
  "2027-03-17": {
    "north": "M72",
    "south": "NGC6712"
  },
  "2027-03-18": {
    "north": "NGC4038",
    "south": "NGC6752"
  },
  "2027-03-19": {
    "north": "M19",
    "south": "M9"
  },
  "2027-03-20": {
    "north": "SH2-136",
    "south": "NGC6723"
  },
  "2027-03-21": {
    "north": "NGC7023",
    "south": "M15"
  },
  "2027-03-22": {
    "north": "NGC6559",
    "south": "NGC7331"
  },
  "2027-03-23": {
    "north": "NGC4656",
    "south": "NGC7009"
  },
  "2027-03-24": {
    "north": "M49",
    "south": "M68"
  },
  "2027-03-25": {
    "north": "NGC7000",
    "south": "NGC6231"
  },
  "2027-03-26": {
    "north": "M53",
    "south": "NGC6514"
  },
  "2027-03-27": {
    "north": "M68",
    "south": "M89"
  },
  "2027-03-28": {
    "north": "NGC7293",
    "south": "NGC6960"
  },
  "2027-03-29": {
    "north": "M109",
    "south": "M22"
  },
  "2027-03-30": {
    "north": "M26",
    "south": "VIRGO_SUPERCLUSTER"
  },
  "2027-03-31": {
    "north": "NGC7662",
    "south": "NGC4945"
  },
  "2027-04-01": {
    "north": "NGC4631",
    "south": "NGC6712"
  },
  "2027-04-02": {
    "north": "M62",
    "south": "M60"
  },
  "2027-04-03": {
    "north": "M90",
    "south": "M21"
  },
  "2027-04-04": {
    "north": "NGC7635",
    "south": "M49"
  },
  "2027-04-05": {
    "north": "M21",
    "south": "M61"
  },
  "2027-04-06": {
    "north": "NGC7814",
    "south": "NGC6231"
  },
  "2027-04-07": {
    "north": "NGC6934",
    "south": "NGC5053"
  },
  "2027-04-08": {
    "north": "M14",
    "south": "M10"
  },
  "2027-04-09": {
    "north": "NGC6514",
    "south": "M53"
  },
  "2027-04-10": {
    "north": "M2",
    "south": "M26"
  },
  "2027-04-11": {
    "north": "M52",
    "south": "M107"
  },
  "2027-04-12": {
    "north": "NGC7380",
    "south": "M80"
  },
  "2027-04-13": {
    "north": "NGC7331",
    "south": "M14"
  },
  "2027-04-14": {
    "north": "M30",
    "south": "M11"
  },
  "2027-04-15": {
    "north": "M27",
    "south": "M75"
  },
  "2027-04-16": {
    "north": "NGC6960",
    "south": "M6"
  },
  "2027-04-17": {
    "north": "M4",
    "south": "NGC6369"
  },
  "2027-04-18": {
    "north": "NGC288",
    "south": "M57"
  },
  "2027-04-19": {
    "north": "M39",
    "south": "NGC6960"
  },
  "2027-04-20": {
    "north": "NGC7009",
    "south": "NGC6541"
  },
  "2027-04-21": {
    "north": "M110",
    "south": "SMC"
  },
  "2027-04-22": {
    "north": "NGC457",
    "south": "M23"
  },
  "2027-04-23": {
    "north": "M16",
    "south": "M72"
  },
  "2027-04-24": {
    "north": "M32",
    "south": "NGC6781"
  },
  "2027-04-25": {
    "north": "M103",
    "south": "NGC6514"
  },
  "2027-04-26": {
    "north": "NGC188",
    "south": "M71"
  },
  "2027-04-27": {
    "north": "NGC604",
    "south": "NGC104"
  },
  "2027-04-28": {
    "north": "NGC404",
    "south": "M8"
  },
  "2027-04-29": {
    "north": "M25",
    "south": "M4"
  },
  "2027-04-30": {
    "north": "M76",
    "south": "NGC6559"
  },
  "2027-05-01": {
    "north": "M31",
    "south": "M9"
  },
  "2027-05-02": {
    "north": "MARKARIANS_CHAIN",
    "south": "NGC6760"
  },
  "2027-05-03": {
    "north": "M74",
    "south": "NGC6188"
  },
  "2027-05-04": {
    "north": "NGC281",
    "south": "M17"
  },
  "2027-05-05": {
    "north": "M33",
    "south": "M5"
  },
  "2027-05-06": {
    "north": "NGC457",
    "south": "M33"
  },
  "2027-05-07": {
    "north": "NGC188",
    "south": "M69"
  },
  "2027-05-08": {
    "north": "M31",
    "south": "M19"
  },
  "2027-05-09": {
    "north": "NGC5746",
    "south": "M7"
  },
  "2027-05-10": {
    "north": "NGC869",
    "south": "NGC288"
  },
  "2027-05-11": {
    "north": "NGC5897",
    "south": "NGC6302"
  },
  "2027-05-12": {
    "north": "M27",
    "south": "M2"
  },
  "2027-05-13": {
    "north": "NGC752",
    "south": "NGC6240"
  },
  "2027-05-14": {
    "north": "M72",
    "south": "M22"
  },
  "2027-05-15": {
    "north": "M74",
    "south": "NGC300"
  },
  "2027-05-16": {
    "north": "M23",
    "south": "M30"
  },
  "2027-05-17": {
    "north": "M19",
    "south": "NGC7009"
  },
  "2027-05-18": {
    "north": "NGC6960",
    "south": "NGC362"
  },
  "2027-05-19": {
    "north": "NGC7009",
    "south": "NGC7814"
  },
  "2027-05-20": {
    "north": "M12",
    "south": "NGC6397"
  },
  "2027-05-21": {
    "north": "M80",
    "south": "M70"
  },
  "2027-05-22": {
    "north": "NGC6366",
    "south": "M56"
  },
  "2027-05-23": {
    "north": "NGC6445",
    "south": "M24"
  },
  "2027-05-24": {
    "north": "NGC281",
    "south": "NGC1073"
  },
  "2027-05-25": {
    "north": "M24",
    "south": "M74"
  },
  "2027-05-26": {
    "north": "M11",
    "south": "M12"
  },
  "2027-05-27": {
    "north": "NGC7023",
    "south": "NGC604"
  },
  "2027-05-28": {
    "north": "M75",
    "south": "NGC6334"
  },
  "2027-05-29": {
    "north": "NGC6240",
    "south": "M28"
  },
  "2027-05-30": {
    "north": "NGC6760",
    "south": "NGC6366"
  },
  "2027-05-31": {
    "north": "M76",
    "south": "NGC7331"
  },
  "2027-06-01": {
    "north": "NGC7814",
    "south": "M15"
  },
  "2027-06-02": {
    "north": "M33",
    "south": "NGC6752"
  },
  "2027-06-03": {
    "north": "M107",
    "south": "M62"
  },
  "2027-06-04": {
    "north": "STEPHANS_QUINTET",
    "south": "M45"
  },
  "2027-06-05": {
    "north": "M14",
    "south": "NGC6164"
  },
  "2027-06-06": {
    "north": "NGC1499",
    "south": "M20"
  },
  "2027-06-07": {
    "north": "M32",
    "south": "M55"
  },
  "2027-06-08": {
    "north": "NGC7331",
    "south": "M77"
  },
  "2027-06-09": {
    "north": "NGC6514",
    "south": "M27"
  },
  "2027-06-10": {
    "north": "M103",
    "south": "NGC7293"
  },
  "2027-06-11": {
    "north": "M62",
    "south": "NGC6934"
  },
  "2027-06-12": {
    "north": "M71",
    "south": "M16"
  },
  "2027-06-13": {
    "north": "NGC7662",
    "south": "M25"
  },
  "2027-06-14": {
    "north": "IC1805",
    "south": "NGC6445"
  },
  "2027-06-15": {
    "north": "NGC6712",
    "south": "NGC6723"
  },
  "2027-06-16": {
    "north": "NGC7293",
    "south": "M11"
  },
  "2027-06-17": {
    "north": "NGC6369",
    "south": "M16"
  },
  "2027-06-18": {
    "north": "NGC6559",
    "south": "NGC6302"
  },
  "2027-06-19": {
    "north": "NGC6826",
    "south": "NGC6752"
  },
  "2027-06-20": {
    "north": "M34",
    "south": "M75"
  },
  "2027-06-21": {
    "north": "NGC6781",
    "south": "NGC6760"
  },
  "2027-06-22": {
    "north": "M69",
    "south": "M6"
  },
  "2027-06-23": {
    "north": "M6",
    "south": "M74"
  },
  "2027-06-24": {
    "north": "M77",
    "south": "M69"
  },
  "2027-06-25": {
    "north": "M15",
    "south": "NGC288"
  },
  "2027-06-26": {
    "north": "NGC891",
    "south": "M24"
  },
  "2027-06-27": {
    "north": "NGC404",
    "south": "M30"
  },
  "2027-06-28": {
    "north": "M45",
    "south": "NGC7814"
  },
  "2027-06-29": {
    "north": "NGC1073",
    "south": "NGC2070"
  },
  "2027-06-30": {
    "north": "NGC7635",
    "south": "NGC300"
  },
  "2027-07-01": {
    "north": "NGC6934",
    "south": "M8"
  },
  "2027-07-02": {
    "north": "NGC884",
    "south": "SMC"
  },
  "2027-07-03": {
    "north": "M2",
    "south": "NGC1851"
  },
  "2027-07-04": {
    "north": "M36",
    "south": "NGC6934"
  },
  "2027-07-05": {
    "north": "M79",
    "south": "NGC6723"
  },
  "2027-07-06": {
    "north": "M78",
    "south": "NGC1073"
  },
  "2027-07-07": {
    "north": "M28",
    "south": "M25"
  },
  "2027-07-08": {
    "north": "M70",
    "south": "M77"
  },
  "2027-07-09": {
    "north": "M55",
    "south": "M79"
  },
  "2027-07-10": {
    "north": "NGC7000",
    "south": "NGC7009"
  },
  "2027-07-11": {
    "north": "NGC7027",
    "south": "NGC362"
  },
  "2027-07-12": {
    "north": "NGC2169",
    "south": "M33"
  },
  "2027-07-13": {
    "north": "M39",
    "south": "M2"
  },
  "2027-07-14": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M1"
  },
  "2027-07-15": {
    "north": "NGC1931",
    "south": "M55"
  },
  "2027-07-16": {
    "north": "M37",
    "south": "M72"
  },
  "2027-07-17": {
    "north": "M35",
    "south": "M37"
  },
  "2027-07-18": {
    "north": "NGC1952",
    "south": "NGC6960"
  },
  "2027-07-19": {
    "north": "NGC1275",
    "south": "M15"
  },
  "2027-07-20": {
    "north": "M1",
    "south": "M78"
  },
  "2027-07-21": {
    "north": "M110",
    "south": "LMC"
  },
  "2027-07-22": {
    "north": "M52",
    "south": "NGC7293"
  },
  "2027-07-23": {
    "north": "NGC2301",
    "south": "NGC7331"
  },
  "2027-07-24": {
    "north": "M38",
    "south": "NGC2264"
  },
  "2027-07-25": {
    "north": "NGC6888",
    "south": "M42"
  },
  "2027-07-26": {
    "north": "NGC2261",
    "south": "NGC104"
  },
  "2027-07-27": {
    "north": "NGC2403",
    "south": "M35"
  },
  "2027-07-28": {
    "north": "M30",
    "south": "NGC604"
  },
  "2027-07-29": {
    "north": "NGC604",
    "south": "NGC2301"
  },
  "2027-07-30": {
    "north": "NGC2392",
    "south": "M93"
  },
  "2027-07-31": {
    "north": "M47",
    "south": "NGC1931"
  },
  "2027-08-01": {
    "north": "NGC2264",
    "south": "NGC2440"
  },
  "2027-08-02": {
    "north": "NGC2419",
    "south": "NGC2261"
  },
  "2027-08-03": {
    "north": "M50",
    "south": "NGC2169"
  },
  "2027-08-04": {
    "north": "M46",
    "south": "NGC2477"
  },
  "2027-08-05": {
    "north": "NGC288",
    "south": "M47"
  },
  "2027-08-06": {
    "north": "M42",
    "south": "M48"
  },
  "2027-08-07": {
    "north": "NGC2237",
    "south": "NGC2516"
  },
  "2027-08-08": {
    "north": "M48",
    "south": "NGC2362"
  },
  "2027-08-09": {
    "north": "NGC2362",
    "south": "NGC2392"
  },
  "2027-08-10": {
    "north": "M41",
    "south": "NGC2451"
  },
  "2027-08-11": {
    "north": "NGC7380",
    "south": "M46"
  },
  "2027-08-12": {
    "north": "M44",
    "south": "NGC1952"
  },
  "2027-08-13": {
    "north": "NGC2359",
    "south": "M45"
  },
  "2027-08-14": {
    "north": "SH2-136",
    "south": "NGC2438"
  },
  "2027-08-15": {
    "north": "NGC2438",
    "south": "NGC2683"
  },
  "2027-08-16": {
    "north": "IC342",
    "south": "M36"
  },
  "2027-08-17": {
    "north": "M67",
    "south": "NGC2359"
  },
  "2027-08-18": {
    "north": "NGC2683",
    "south": "NGC2237"
  },
  "2027-08-19": {
    "north": "NGC2440",
    "south": "M67"
  },
  "2027-08-20": {
    "north": "M93",
    "south": "M50"
  },
  "2027-08-21": {
    "north": "NGC2264",
    "south": "IC2391"
  },
  "2027-08-22": {
    "north": "NGC7293",
    "south": "M44"
  },
  "2027-08-23": {
    "north": "NGC752",
    "south": "M41"
  },
  "2027-08-24": {
    "north": "NGC2261",
    "south": "M36"
  },
  "2027-08-25": {
    "north": "M30",
    "south": "NGC2438"
  },
  "2027-08-26": {
    "north": "NGC2419",
    "south": "NGC2070"
  },
  "2027-08-27": {
    "north": "M74",
    "south": "M33"
  },
  "2027-08-28": {
    "north": "M44",
    "south": "NGC2264"
  },
  "2027-08-29": {
    "north": "M67",
    "south": "SMC"
  },
  "2027-08-30": {
    "north": "NGC2440",
    "south": "NGC2451"
  },
  "2027-08-31": {
    "north": "NGC1931",
    "south": "NGC104"
  },
  "2027-09-01": {
    "north": "M52",
    "south": "LMC"
  },
  "2027-09-02": {
    "north": "NGC7662",
    "south": "NGC1073"
  },
  "2027-09-03": {
    "north": "M41",
    "south": "M74"
  },
  "2027-09-04": {
    "north": "M77",
    "south": "NGC7331"
  },
  "2027-09-05": {
    "north": "M37",
    "south": "NGC2169"
  },
  "2027-09-06": {
    "north": "M82",
    "south": "NGC1952"
  },
  "2027-09-07": {
    "north": "NGC3184",
    "south": "NGC2392"
  },
  "2027-09-08": {
    "north": "M110",
    "south": "NGC3132"
  },
  "2027-09-09": {
    "north": "NGC869",
    "south": "M47"
  },
  "2027-09-10": {
    "north": "NGC1073",
    "south": "NGC604"
  },
  "2027-09-11": {
    "north": "M45",
    "south": "NGC3293"
  },
  "2027-09-12": {
    "north": "MIZAR_AND_ALCOR",
    "south": "M50"
  },
  "2027-09-13": {
    "north": "M48",
    "south": "NGC1931"
  },
  "2027-09-14": {
    "north": "NGC604",
    "south": "NGC300"
  },
  "2027-09-15": {
    "north": "M42",
    "south": "NGC3372"
  },
  "2027-09-16": {
    "north": "NGC2683",
    "south": "M42"
  },
  "2027-09-17": {
    "north": "M32",
    "south": "M95"
  },
  "2027-09-18": {
    "north": "NGC7814",
    "south": "NGC3521"
  },
  "2027-09-19": {
    "north": "M96",
    "south": "M1"
  },
  "2027-09-20": {
    "north": "M81",
    "south": "IC2391"
  },
  "2027-09-21": {
    "north": "M47",
    "south": "NGC3603"
  },
  "2027-09-22": {
    "north": "NGC2438",
    "south": "NGC1851"
  },
  "2027-09-23": {
    "north": "NGC3521",
    "south": "NGC7814"
  },
  "2027-09-24": {
    "north": "M33",
    "south": "M66"
  },
  "2027-09-25": {
    "north": "NGC3310",
    "south": "M96"
  },
  "2027-09-26": {
    "north": "M35",
    "south": "M41"
  },
  "2027-09-27": {
    "north": "M1",
    "south": "NGC2362"
  },
  "2027-09-28": {
    "north": "NGC1952",
    "south": "M65"
  },
  "2027-09-29": {
    "north": "M97",
    "south": "M105"
  },
  "2027-09-30": {
    "north": "M31",
    "south": "M46"
  },
  "2027-10-01": {
    "north": "M105",
    "south": "M37"
  },
  "2027-10-02": {
    "north": "M65",
    "south": "NGC2261"
  },
  "2027-10-03": {
    "north": "M50",
    "south": "M67"
  },
  "2027-10-04": {
    "north": "M109",
    "south": "NGC2359"
  },
  "2027-10-05": {
    "north": "NGC2169",
    "south": "NGC288"
  },
  "2027-10-06": {
    "north": "M38",
    "south": "NGC2683"
  },
  "2027-10-07": {
    "north": "M79",
    "south": "NGC3576"
  },
  "2027-10-08": {
    "north": "M76",
    "south": "NGC362"
  },
  "2027-10-09": {
    "north": "M36",
    "south": "NGC2301"
  },
  "2027-10-10": {
    "north": "NGC891",
    "south": "M91"
  },
  "2027-10-11": {
    "north": "IC2574",
    "south": "M45"
  },
  "2027-10-12": {
    "north": "NGC188",
    "south": "NGC2516"
  },
  "2027-10-13": {
    "north": "NGC4565",
    "south": "NGC3766"
  },
  "2027-10-14": {
    "north": "M91",
    "south": "NGC4725"
  },
  "2027-10-15": {
    "north": "NGC2359",
    "south": "M59"
  },
  "2027-10-16": {
    "north": "M59",
    "south": "M79"
  },
  "2027-10-17": {
    "north": "M84",
    "south": "IC2602"
  },
  "2027-10-18": {
    "north": "M90",
    "south": "M93"
  },
  "2027-10-19": {
    "north": "M60",
    "south": "M61"
  },
  "2027-10-20": {
    "north": "M104",
    "south": "NGC4631"
  },
  "2027-10-21": {
    "north": "M78",
    "south": "NGC4755"
  },
  "2027-10-22": {
    "north": "M106",
    "south": "M104"
  },
  "2027-10-23": {
    "north": "M94",
    "south": "M53"
  },
  "2027-10-24": {
    "north": "M108",
    "south": "M100"
  },
  "2027-10-25": {
    "north": "NGC4656",
    "south": "M68"
  },
  "2027-10-26": {
    "north": "VIRGO_SUPERCLUSTER",
    "south": "NGC4039"
  },
  "2027-10-27": {
    "north": "M51",
    "south": "M90"
  },
  "2027-10-28": {
    "north": "M64",
    "south": "VIRGO_SUPERCLUSTER"
  },
  "2027-10-29": {
    "north": "M86",
    "south": "NGC2477"
  },
  "2027-10-30": {
    "north": "NGC4038",
    "south": "NGC3628"
  },
  "2027-10-31": {
    "north": "M61",
    "south": "M84"
  },
  "2027-11-01": {
    "north": "NGC4725",
    "south": "NGC4945"
  },
  "2027-11-02": {
    "north": "NGC4631",
    "south": "M85"
  },
  "2027-11-03": {
    "north": "M68",
    "south": "NGC4565"
  },
  "2027-11-04": {
    "north": "M93",
    "south": "M3"
  },
  "2027-11-05": {
    "north": "M85",
    "south": "M64"
  },
  "2027-11-06": {
    "north": "NGC4147",
    "south": "NGC2237"
  },
  "2027-11-07": {
    "north": "IC1805",
    "south": "NGC5139"
  },
  "2027-11-08": {
    "north": "M66",
    "south": "M83"
  },
  "2027-11-09": {
    "north": "NGC4244",
    "south": "NGC4147"
  },
  "2027-11-10": {
    "north": "NGC2392",
    "south": "M49"
  },
  "2027-11-11": {
    "north": "M63",
    "south": "M48"
  },
  "2027-11-12": {
    "north": "M87",
    "south": "M86"
  },
  "2027-11-13": {
    "north": "M99",
    "south": "NGC5053"
  },
  "2027-11-14": {
    "north": "NGC1499",
    "south": "M87"
  },
  "2027-11-15": {
    "north": "NGC3628",
    "south": "NGC4656"
  },
  "2027-11-16": {
    "north": "NGC2362",
    "south": "NGC3532"
  },
  "2027-11-17": {
    "north": "NGC2301",
    "south": "NGC5466"
  },
  "2027-11-18": {
    "north": "M83",
    "south": "M89"
  },
  "2027-11-19": {
    "north": "NGC4039",
    "south": "M78"
  },
  "2027-11-20": {
    "north": "NGC2841",
    "south": "NGC4038"
  },
  "2027-11-21": {
    "north": "M46",
    "south": "M44"
  },
  "2027-11-22": {
    "north": "NGC4449",
    "south": "NGC5822"
  },
  "2027-11-23": {
    "north": "NGC2237",
    "south": "NGC2440"
  },
  "2027-11-24": {
    "north": "M101",
    "south": "NGC5897"
  },
  "2027-11-25": {
    "north": "M3",
    "south": "NGC5128"
  },
  "2027-11-26": {
    "north": "NGC5746",
    "south": "M99"
  },
  "2027-11-27": {
    "north": "NGC5053",
    "south": "M60"
  },
  "2027-11-28": {
    "north": "NGC5466",
    "south": "M5"
  },
  "2027-11-29": {
    "north": "M89",
    "south": "M35"
  },
  "2027-11-30": {
    "north": "M95",
    "south": "NGC5746"
  },
  "2027-12-01": {
    "north": "NGC2403",
    "south": "M65"
  },
  "2027-12-02": {
    "north": "NGC5897",
    "south": "NGC3532"
  },
  "2027-12-03": {
    "north": "M102",
    "south": "NGC2301"
  },
  "2027-12-04": {
    "north": "M49",
    "south": "M83"
  },
  "2027-12-05": {
    "north": "M53",
    "south": "M61"
  },
  "2027-12-06": {
    "north": "M5",
    "south": "M85"
  },
  "2027-12-07": {
    "north": "M80",
    "south": "M79"
  },
  "2027-12-08": {
    "north": "M4",
    "south": "NGC2516"
  },
  "2027-12-09": {
    "north": "M100",
    "south": "NGC3628"
  },
  "2027-12-10": {
    "north": "M107",
    "south": "NGC3293"
  },
  "2027-12-11": {
    "north": "NGC3310",
    "south": "NGC2451"
  },
  "2027-12-12": {
    "north": "NGC2169",
    "south": "NGC5466"
  },
  "2027-12-13": {
    "north": "M79",
    "south": "M68"
  },
  "2027-12-14": {
    "north": "M84",
    "south": "NGC1952"
  },
  "2027-12-15": {
    "north": "M64",
    "south": "NGC4147"
  },
  "2027-12-16": {
    "north": "NGC5466",
    "south": "M49"
  },
  "2027-12-17": {
    "north": "M82",
    "south": "NGC2362"
  },
  "2027-12-18": {
    "north": "M104",
    "south": "M90"
  },
  "2027-12-19": {
    "north": "NGC4244",
    "south": "NGC2477"
  },
  "2027-12-20": {
    "north": "M50",
    "south": "LMC"
  },
  "2027-12-21": {
    "north": "NGC6229",
    "south": "M48"
  },
  "2027-12-22": {
    "north": "M10",
    "south": "M44"
  },
  "2027-12-23": {
    "north": "M81",
    "south": "M99"
  },
  "2027-12-24": {
    "north": "M100",
    "south": "VIRGO_SUPERCLUSTER"
  },
  "2027-12-25": {
    "north": "NGC3521",
    "south": "M50"
  },
  "2027-12-26": {
    "north": "NGC6366",
    "south": "M105"
  },
  "2027-12-27": {
    "north": "NGC5746",
    "south": "NGC4631"
  },
  "2027-12-28": {
    "north": "M46",
    "south": "M80"
  },
  "2027-12-29": {
    "north": "M99",
    "south": "M100"
  },
  "2027-12-30": {
    "north": "NGC2419",
    "south": "NGC5053"
  },
  "2027-12-31": {
    "north": "NGC2362",
    "south": "NGC5822"
  },
  "2025-01-01": {
    "north": "NGC3184",
    "south": "NGC2440"
  },
  "2025-01-02": {
    "north": "M83",
    "south": "M10"
  },
  "2025-01-03": {
    "north": "M7",
    "south": "NGC5897"
  },
  "2025-01-04": {
    "north": "M68",
    "south": "M5"
  },
  "2025-01-05": {
    "north": "M20",
    "south": "M46"
  },
  "2025-01-06": {
    "north": "NGC5897",
    "south": "M41"
  },
  "2025-01-07": {
    "north": "M48",
    "south": "NGC2237"
  },
  "2025-01-08": {
    "north": "NGC4449",
    "south": "NGC2438"
  },
  "2025-01-09": {
    "north": "M108",
    "south": "NGC5139"
  },
  "2025-01-10": {
    "north": "M62",
    "south": "M9"
  },
  "2025-01-11": {
    "north": "NGC6240",
    "south": "M104"
  },
  "2025-01-12": {
    "north": "NGC5053",
    "south": "NGC6334"
  },
  "2025-01-13": {
    "north": "NGC2301",
    "south": "NGC3132"
  },
  "2025-01-14": {
    "north": "M22",
    "south": "NGC3603"
  },
  "2025-01-15": {
    "north": "NGC2841",
    "south": "NGC6302"
  },
  "2025-01-16": {
    "north": "NGC4565",
    "south": "M53"
  },
  "2025-01-17": {
    "north": "M93",
    "south": "M47"
  },
  "2025-01-18": {
    "north": "M14",
    "south": "M3"
  },
  "2025-01-19": {
    "north": "IC2574",
    "south": "NGC5746"
  },
  "2025-01-20": {
    "north": "M91",
    "south": "NGC6240"
  },
  "2025-01-21": {
    "north": "M80",
    "south": "NGC3766"
  },
  "2025-01-22": {
    "north": "NGC4725",
    "south": "M107"
  },
  "2025-01-23": {
    "north": "M85",
    "south": "NGC6366"
  },
  "2025-01-24": {
    "north": "M21",
    "south": "M93"
  },
  "2025-01-25": {
    "north": "NGC4656",
    "south": "NGC4565"
  },
  "2025-01-26": {
    "north": "M70",
    "south": "NGC4038"
  },
  "2025-01-27": {
    "north": "M101",
    "south": "NGC3372"
  },
  "2025-01-28": {
    "north": "M3",
    "south": "NGC4656"
  },
  "2025-01-29": {
    "north": "M17",
    "south": "M55"
  },
  "2025-01-30": {
    "north": "NGC6819",
    "south": "M56"
  },
  "2025-01-31": {
    "north": "M56",
    "south": "M70"
  },
  "2025-02-01": {
    "north": "NGC6445",
    "south": "M4"
  },
  "2025-02-02": {
    "north": "M65",
    "south": "M89"
  },
  "2025-02-03": {
    "north": "M4",
    "south": "M67"
  },
  "2025-02-04": {
    "north": "M23",
    "south": "M96"
  },
  "2025-02-05": {
    "north": "M25",
    "south": "NGC6397"
  },
  "2025-02-06": {
    "north": "M95",
    "south": "NGC6514"
  },
  "2025-02-07": {
    "north": "M97",
    "south": "NGC6369"
  },
  "2025-02-08": {
    "north": "M49",
    "south": "M27"
  },
  "2025-02-09": {
    "north": "M87",
    "south": "M8"
  },
  "2025-02-10": {
    "north": "M61",
    "south": "M75"
  },
  "2025-02-11": {
    "north": "NGC6559",
    "south": "M60"
  },
  "2025-02-12": {
    "north": "NGC6888",
    "south": "NGC3521"
  },
  "2025-02-13": {
    "north": "NGC4038",
    "south": "M25"
  },
  "2025-02-14": {
    "north": "M66",
    "south": "NGC3576"
  },
  "2025-02-15": {
    "north": "M75",
    "south": "M71"
  },
  "2025-02-16": {
    "north": "NGC6712",
    "south": "NGC7009"
  },
  "2025-02-17": {
    "north": "M28",
    "south": "M86"
  },
  "2025-02-18": {
    "north": "NGC4631",
    "south": "M26"
  },
  "2025-02-19": {
    "north": "M59",
    "south": "NGC6231"
  },
  "2025-02-20": {
    "north": "NGC7027",
    "south": "M16"
  },
  "2025-02-21": {
    "north": "M11",
    "south": "M12"
  },
  "2025-02-22": {
    "north": "M16",
    "south": "M62"
  },
  "2025-02-23": {
    "north": "NGC6781",
    "south": "M95"
  },
  "2025-02-24": {
    "north": "M69",
    "south": "M20"
  },
  "2025-02-25": {
    "north": "M15",
    "south": "M69"
  },
  "2025-02-26": {
    "north": "NGC7009",
    "south": "NGC6445"
  },
  "2025-02-27": {
    "north": "NGC6543",
    "south": "M30"
  },
  "2025-02-28": {
    "north": "M24",
    "south": "M72"
  },
  "2025-02-29": {
    "north": "NGC6514",
    "south": "NGC5128"
  },
  "2026-02-29": {
    "north": "VIRGO_SUPERCLUSTER",
    "south": "NGC6559"
  },
  "2027-02-29": {
    "north": "VIRGO_SUPERCLUSTER",
    "south": "NGC5128"
  },
  "2025-03-01": {
    "north": "VIRGO_SUPERCLUSTER",
    "south": "M11"
  },
  "2025-03-02": {
    "north": "M57",
    "south": "NGC6712"
  },
  "2025-03-03": {
    "north": "M63",
    "south": "NGC6559"
  },
  "2025-03-04": {
    "north": "M105",
    "south": "NGC6723"
  },
  "2025-03-05": {
    "north": "M96",
    "south": "M91"
  },
  "2025-03-06": {
    "north": "NGC6826",
    "south": "M2"
  },
  "2025-03-07": {
    "north": "M5",
    "south": "NGC6760"
  },
  "2025-03-08": {
    "north": "M106",
    "south": "M15"
  },
  "2025-03-09": {
    "north": "M13",
    "south": "M84"
  },
  "2025-03-10": {
    "north": "NGC7023",
    "south": "M19"
  },
  "2025-03-11": {
    "north": "M55",
    "south": "M17"
  },
  "2025-03-12": {
    "north": "M29",
    "south": "NGC4945"
  },
  "2025-03-13": {
    "north": "M89",
    "south": "NGC7293"
  },
  "2025-03-14": {
    "north": "M92",
    "south": "NGC6934"
  },
  "2025-03-15": {
    "north": "NGC6503",
    "south": "M23"
  },
  "2025-03-16": {
    "north": "SH2-136",
    "south": "M57"
  },
  "2025-03-17": {
    "north": "M60",
    "south": "M24"
  },
  "2025-03-18": {
    "north": "M27",
    "south": "NGC6752"
  },
  "2025-03-19": {
    "north": "NGC6960",
    "south": "M87"
  },
  "2025-03-20": {
    "north": "NGC6760",
    "south": "M59"
  },
  "2025-03-21": {
    "north": "NGC4039",
    "south": "NGC6188"
  },
  "2025-03-22": {
    "north": "M30",
    "south": "NGC4725"
  },
  "2025-03-23": {
    "north": "M51",
    "south": "NGC6781"
  },
  "2025-03-24": {
    "north": "M26",
    "south": "NGC6960"
  },
  "2025-03-25": {
    "north": "NGC6934",
    "south": "M28"
  },
  "2025-03-26": {
    "north": "NGC6369",
    "south": "NGC4755"
  },
  "2025-03-27": {
    "north": "M39",
    "south": "M22"
  },
  "2025-03-28": {
    "north": "NGC4147",
    "south": "M21"
  },
  "2025-03-29": {
    "north": "NGC7662",
    "south": "NGC6164"
  },
  "2025-03-30": {
    "north": "NGC7000",
    "south": "M14"
  },
  "2025-03-31": {
    "north": "NGC7635",
    "south": "M7"
  },
  "2025-04-01": {
    "north": "M71",
    "south": "M6"
  },
};

const DSO_DETAILS = {
  "M1": {
    "id": "M1",
    "name": "Crab Nebula",
    "type": "SuperNova Remnant",
    "constellation": "Tau",
    "ra_deg": 83.6325,
    "dec_deg": 22.0175,
    "ra_hms": "05:34:31.80",
    "dec_dms": "+22:01:03.0"
  },
  "M2": {
    "id": "M2",
    "name": "M2",
    "type": "Globular Cluster",
    "constellation": "Aqr",
    "ra_deg": 323.3625833333333,
    "dec_deg": -0.82325,
    "ra_hms": "21:33:27.02",
    "dec_dms": "-00:49:23.7"
  },
  "M3": {
    "id": "M3",
    "name": "M3",
    "type": "Globular Cluster",
    "constellation": "CVn",
    "ra_deg": 205.5484166666666,
    "dec_deg": 28.377277777777778,
    "ra_hms": "13:42:11.62",
    "dec_dms": "+28:22:38.2"
  },
  "M4": {
    "id": "M4",
    "name": "M4",
    "type": "Globular Cluster",
    "constellation": "Sco",
    "ra_deg": 245.89675,
    "dec_deg": -26.52575,
    "ra_hms": "16:23:35.22",
    "dec_dms": "-26:31:32.7"
  },
  "M5": {
    "id": "M5",
    "name": "M5",
    "type": "Globular Cluster",
    "constellation": "Ser",
    "ra_deg": 229.63841666666664,
    "dec_deg": 2.081027777777778,
    "ra_hms": "15:18:33.22",
    "dec_dms": "+02:04:51.7"
  },
  "M6": {
    "id": "M6",
    "name": "Butterfly Cluster",
    "type": "Open Cluster",
    "constellation": "Sco",
    "ra_deg": 265.06916666666666,
    "dec_deg": -32.24194444444444,
    "ra_hms": "17:40:16.60",
    "dec_dms": "-32:14:31.0"
  },
  "M7": {
    "id": "M7",
    "name": "Ptolemy Cluster",
    "type": "Open Cluster",
    "constellation": "Sco",
    "ra_deg": 268.4470833333333,
    "dec_deg": -34.84111111111111,
    "ra_hms": "17:53:47.30",
    "dec_dms": "-34:50:28.0"
  },
  "M9": {
    "id": "M9",
    "name": "M9",
    "type": "Globular Cluster",
    "constellation": "Oph",
    "ra_deg": 259.7990833333333,
    "dec_deg": -18.51625,
    "ra_hms": "17:19:11.78",
    "dec_dms": "-18:30:58.5"
  },
  "M10": {
    "id": "M10",
    "name": "M10",
    "type": "Globular Cluster",
    "constellation": "Oph",
    "ra_deg": 254.28770833333328,
    "dec_deg": -4.100305555555555,
    "ra_hms": "16:57:09.05",
    "dec_dms": "-04:06:01.1"
  },
  "M11": {
    "id": "M11",
    "name": "Wild Duck Cluster",
    "type": "Open Cluster",
    "constellation": "Sct",
    "ra_deg": 282.7658333333333,
    "dec_deg": -6.271944444444444,
    "ra_hms": "18:51:03.80",
    "dec_dms": "-06:16:19.0"
  },
  "M12": {
    "id": "M12",
    "name": "Gumball Globular",
    "type": "Globular Cluster",
    "constellation": "Oph",
    "ra_deg": 251.80908333333335,
    "dec_deg": -1.9485277777777779,
    "ra_hms": "16:47:14.18",
    "dec_dms": "-01:56:54.7"
  },
  "M13": {
    "id": "M13",
    "name": "Great Hercules Cluster",
    "type": "Globular Cluster",
    "constellation": "Her",
    "ra_deg": 250.423475,
    "dec_deg": 36.46131944444445,
    "ra_hms": "16:41:41.63",
    "dec_dms": "+36:27:40.8"
  },
  "M14": {
    "id": "M14",
    "name": "M14",
    "type": "Globular Cluster",
    "constellation": "Oph",
    "ra_deg": 264.400625,
    "dec_deg": -3.2459166666666666,
    "ra_hms": "17:37:36.15",
    "dec_dms": "-03:14:45.3"
  },
  "M15": {
    "id": "M15",
    "name": "Great Pegasus Cluster",
    "type": "Globular Cluster",
    "constellation": "Peg",
    "ra_deg": 322.49304166666667,
    "dec_deg": 12.167,
    "ra_hms": "21:29:58.33",
    "dec_dms": "+12:10:01.2"
  },
  "M16": {
    "id": "M16",
    "name": "Eagle Nebula",
    "type": "Emission Nebula",
    "constellation": "Ser",
    "ra_deg": 274.68791666666664,
    "dec_deg": -13.791944444444445,
    "ra_hms": "18:18:45.10",
    "dec_dms": "-13:47:31.0"
  },
  "M19": {
    "id": "M19",
    "name": "M19",
    "type": "Globular Cluster",
    "constellation": "Oph",
    "ra_deg": 255.6570416666667,
    "dec_deg": -26.267944444444442,
    "ra_hms": "17:02:37.69",
    "dec_dms": "-26:16:04.6"
  },
  "M20": {
    "id": "M20",
    "name": "Trifid Nebula",
    "type": "Emission Nebula",
    "constellation": "Sgr",
    "ra_deg": 270.675,
    "dec_deg": -22.971666666666664,
    "ra_hms": "18:02:42.00",
    "dec_dms": "-22:58:18.0"
  },
  "M21": {
    "id": "M21",
    "name": "Webb's Cross",
    "type": "Open Cluster",
    "constellation": "Sgr",
    "ra_deg": 271.0358333333333,
    "dec_deg": -22.505,
    "ra_hms": "18:04:08.60",
    "dec_dms": "-22:30:18.0"
  },
  "M22": {
    "id": "M22",
    "name": "Great Sagittarius Cluster",
    "type": "Globular Cluster",
    "constellation": "Sgr",
    "ra_deg": 279.09975,
    "dec_deg": -23.90475,
    "ra_hms": "18:36:23.94",
    "dec_dms": "-23:54:17.1"
  },
  "M23": {
    "id": "M23",
    "name": "M23",
    "type": "Open Cluster",
    "constellation": "Sgr",
    "ra_deg": 269.2370833333333,
    "dec_deg": -18.986944444444447,
    "ra_hms": "17:56:56.90",
    "dec_dms": "-18:59:13.0"
  },
  "M24": {
    "id": "M24",
    "name": "Sagittarius Star Cloud",
    "type": "Association of Stars",
    "constellation": "Sgr",
    "ra_deg": 274.19999999999993,
    "dec_deg": -18.55,
    "ra_hms": "18:16:48.00",
    "dec_dms": "-18:33:00.0"
  },
  "M25": {
    "id": "M25",
    "name": "M25",
    "type": "Open Cluster",
    "constellation": "Sgr",
    "ra_deg": 277.9370833333333,
    "dec_deg": -19.11388888888889,
    "ra_hms": "18:31:44.90",
    "dec_dms": "-19:06:50.0"
  },
  "M26": {
    "id": "M26",
    "name": "M26",
    "type": "Open Cluster",
    "constellation": "Sct",
    "ra_deg": 281.3170833333333,
    "dec_deg": -9.386111111111111,
    "ra_hms": "18:45:16.10",
    "dec_dms": "-09:23:10.0"
  },
  "M27": {
    "id": "M27",
    "name": "Dumbbell Nebula",
    "type": "Planetary Nebula",
    "constellation": "Vul",
    "ra_deg": 299.90151327087,
    "dec_deg": 22.72119779432,
    "ra_hms": "19:59:36.36",
    "dec_dms": "+22:43:16.3"
  },
  "M28": {
    "id": "M28",
    "name": "M28",
    "type": "Globular Cluster",
    "constellation": "Sgr",
    "ra_deg": 276.1370416666666,
    "dec_deg": -24.869833333333332,
    "ra_hms": "18:24:32.89",
    "dec_dms": "-24:52:11.4"
  },
  "M29": {
    "id": "M29",
    "name": "Cooling Tower Cluster",
    "type": "Open Cluster",
    "constellation": "Cyg",
    "ra_deg": 305.94291666666663,
    "dec_deg": 38.48694444444445,
    "ra_hms": "20:23:46.30",
    "dec_dms": "+38:29:13.0"
  },
  "M30": {
    "id": "M30",
    "name": "Jellyfish Cluster",
    "type": "Globular Cluster",
    "constellation": "Cap",
    "ra_deg": 325.0921666666666,
    "dec_deg": -23.179861111111112,
    "ra_hms": "21:40:22.12",
    "dec_dms": "-23:10:47.5"
  },
  "M31": {
    "id": "M31",
    "name": "Andromeda Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "And",
    "ra_deg": 10.684708333333331,
    "dec_deg": 41.26875,
    "ra_hms": "00:42:44.33",
    "dec_dms": "+41:16:07.5"
  },
  "M32": {
    "id": "M32",
    "name": "M32",
    "type": "Galaxy",
    "constellation": "And",
    "ra_deg": 10.674269999999998,
    "dec_deg": 40.86517,
    "ra_hms": "00:42:41.82",
    "dec_dms": "+40:51:54.6"
  },
  "M33": {
    "id": "M33",
    "name": "Triangulum Galaxy",
    "type": "Galaxy",
    "constellation": "Tri",
    "ra_deg": 23.46206906218,
    "dec_deg": 30.66017511198,
    "ra_hms": "01:33:50.90",
    "dec_dms": "+30:39:36.6"
  },
  "M34": {
    "id": "M34",
    "name": "Spiral Cluster",
    "type": "Open Cluster",
    "constellation": "Per",
    "ra_deg": 40.530833333333334,
    "dec_deg": 42.721944444444446,
    "ra_hms": "02:42:07.40",
    "dec_dms": "+42:43:19.0"
  },
  "M35": {
    "id": "M35",
    "name": "Shoe-Buckle Cluster",
    "type": "Open Cluster",
    "constellation": "Gem",
    "ra_deg": 92.27208333333333,
    "dec_deg": 24.33611111111111,
    "ra_hms": "06:09:05.30",
    "dec_dms": "+24:20:10.0"
  },
  "M36": {
    "id": "M36",
    "name": "Pinwheel Cluster",
    "type": "Open Cluster",
    "constellation": "Aur",
    "ra_deg": 84.08416666666666,
    "dec_deg": 34.135,
    "ra_hms": "05:36:20.20",
    "dec_dms": "+34:08:06.0"
  },
  "M37": {
    "id": "M37",
    "name": "Salt and Pepper Cluster",
    "type": "Open Cluster",
    "constellation": "Aur",
    "ra_deg": 88.07416666666667,
    "dec_deg": 32.544999999999995,
    "ra_hms": "05:52:17.80",
    "dec_dms": "+32:32:42.0"
  },
  "M38": {
    "id": "M38",
    "name": "Starfish Cluster",
    "type": "Open Cluster",
    "constellation": "Aur",
    "ra_deg": 82.16708333333332,
    "dec_deg": 35.823888888888895,
    "ra_hms": "05:28:40.10",
    "dec_dms": "+35:49:26.0"
  },
  "M39": {
    "id": "M39",
    "name": "Pyramid Cluster",
    "type": "Open Cluster",
    "constellation": "Cyg",
    "ra_deg": 322.88916666666665,
    "dec_deg": 48.246944444444445,
    "ra_hms": "21:31:33.40",
    "dec_dms": "+48:14:49.0"
  },
  "M41": {
    "id": "M41",
    "name": "Little Beehive Cluster",
    "type": "Open Cluster",
    "constellation": "CMa",
    "ra_deg": 101.49916666666665,
    "dec_deg": -20.71611111111111,
    "ra_hms": "06:45:59.80",
    "dec_dms": "-20:42:58.0"
  },
  "M42": {
    "id": "M42",
    "name": "Orion Nebula",
    "type": "HII Region",
    "constellation": "Ori",
    "ra_deg": 83.82,
    "dec_deg": -5.3875,
    "ra_hms": "05:35:16.80",
    "dec_dms": "-05:23:15.0"
  },
  "M44": {
    "id": "M44",
    "name": "Beehive Cluster",
    "type": "Open Cluster",
    "constellation": "Cnc",
    "ra_deg": 130.05416666666665,
    "dec_deg": 19.621111111111112,
    "ra_hms": "08:40:13.00",
    "dec_dms": "+19:37:16.0"
  },
  "M45": {
    "id": "M45",
    "name": "The Pleiades",
    "type": "Open Cluster",
    "constellation": "Tau",
    "ra_deg": 56.60083333333333,
    "dec_deg": 24.11388888888889,
    "ra_hms": "03:46:24.20",
    "dec_dms": "+24:06:50.0"
  },
  "M46": {
    "id": "M46",
    "name": "M46",
    "type": "Open Cluster",
    "constellation": "Pup",
    "ra_deg": 115.445,
    "dec_deg": -14.84388888888889,
    "ra_hms": "07:41:46.80",
    "dec_dms": "-14:50:38.0"
  },
  "M47": {
    "id": "M47",
    "name": "M47",
    "type": "Open Cluster",
    "constellation": "Pup",
    "ra_deg": 114.14708333333331,
    "dec_deg": -14.488888888888889,
    "ra_hms": "07:36:35.30",
    "dec_dms": "-14:29:20.0"
  },
  "M48": {
    "id": "M48",
    "name": "M48",
    "type": "Open Cluster",
    "constellation": "Hya",
    "ra_deg": 123.41208333333331,
    "dec_deg": -5.726111111111111,
    "ra_hms": "08:13:38.90",
    "dec_dms": "-05:43:34.0"
  },
  "M50": {
    "id": "M50",
    "name": "Heart-Shaped Cluster",
    "type": "Open Cluster",
    "constellation": "Mon",
    "ra_deg": 105.68416666666664,
    "dec_deg": -8.365,
    "ra_hms": "07:02:44.20",
    "dec_dms": "-08:21:54.0"
  },
  "M51": {
    "id": "M51",
    "name": "Whirlpool Galaxy",
    "type": "Seyfert 2 Galaxy",
    "constellation": "CVn",
    "ra_deg": 202.46957499999996,
    "dec_deg": 47.19525833333333,
    "ra_hms": "13:29:52.70",
    "dec_dms": "+47:11:42.9"
  },
  "M52": {
    "id": "M52",
    "name": "Scorpion Cluster",
    "type": "Open Cluster",
    "constellation": "Cas",
    "ra_deg": 351.19499999999994,
    "dec_deg": 61.59,
    "ra_hms": "23:24:46.80",
    "dec_dms": "+61:35:24.0"
  },
  "M53": {
    "id": "M53",
    "name": "M53",
    "type": "Globular Cluster",
    "constellation": "Com",
    "ra_deg": 198.2302083333333,
    "dec_deg": 18.168166666666668,
    "ra_hms": "13:12:55.25",
    "dec_dms": "+18:10:05.4"
  },
  "M55": {
    "id": "M55",
    "name": "Specter Cluster",
    "type": "Globular Cluster",
    "constellation": "Sgr",
    "ra_deg": 294.9987916666666,
    "dec_deg": -30.96475,
    "ra_hms": "19:39:59.71",
    "dec_dms": "-30:57:53.1"
  },
  "M56": {
    "id": "M56",
    "name": "M56",
    "type": "Globular Cluster",
    "constellation": "Lyr",
    "ra_deg": 289.1482083333333,
    "dec_deg": 30.18347222222222,
    "ra_hms": "19:16:35.57",
    "dec_dms": "+30:11:00.5"
  },
  "M57": {
    "id": "M57",
    "name": "Ring Nebula",
    "type": "Planetary Nebula",
    "constellation": "Lyr",
    "ra_deg": 283.39623652462996,
    "dec_deg": 33.029134246539996,
    "ra_hms": "18:53:35.10",
    "dec_dms": "+33:01:44.9"
  },
  "M62": {
    "id": "M62",
    "name": "Flickering Globular",
    "type": "Globular Cluster",
    "constellation": "Oph",
    "ra_deg": 255.30249999999995,
    "dec_deg": -30.112361111111113,
    "ra_hms": "17:01:12.60",
    "dec_dms": "-30:06:44.5"
  },
  "M63": {
    "id": "M63",
    "name": "Sunflower Galaxy",
    "type": "Active Galactic Nuclei",
    "constellation": "CVn",
    "ra_deg": 198.95530912246997,
    "dec_deg": 42.02936891003,
    "ra_hms": "13:15:49.27",
    "dec_dms": "+42:01:45.7"
  },
  "M64": {
    "id": "M64",
    "name": "Black Eye Galaxy",
    "type": "Seyfert Galaxy",
    "constellation": "Com",
    "ra_deg": 194.18206666666663,
    "dec_deg": 21.682658333333336,
    "ra_hms": "12:56:43.70",
    "dec_dms": "+21:40:57.6"
  },
  "M67": {
    "id": "M67",
    "name": "Golden Eye Cluster",
    "type": "Open Cluster",
    "constellation": "Cnc",
    "ra_deg": 132.8458333333333,
    "dec_deg": 11.81388888888889,
    "ra_hms": "08:51:23.00",
    "dec_dms": "+11:48:50.0"
  },
  "M68": {
    "id": "M68",
    "name": "M68",
    "type": "Globular Cluster",
    "constellation": "Hya",
    "ra_deg": 189.86658333333332,
    "dec_deg": -26.744055555555555,
    "ra_hms": "12:39:27.98",
    "dec_dms": "-26:44:38.6"
  },
  "M69": {
    "id": "M69",
    "name": "M69",
    "type": "Globular Cluster",
    "constellation": "Sgr",
    "ra_deg": 277.84624999999994,
    "dec_deg": -32.348083333333335,
    "ra_hms": "18:31:23.10",
    "dec_dms": "-32:20:53.1"
  },
  "M70": {
    "id": "M70",
    "name": "M70",
    "type": "Globular Cluster",
    "constellation": "Sgr",
    "ra_deg": 280.8031666666666,
    "dec_deg": -32.29211111111111,
    "ra_hms": "18:43:12.76",
    "dec_dms": "-32:17:31.6"
  },
  "M71": {
    "id": "M71",
    "name": "Angelfish Cluster",
    "type": "Globular Cluster",
    "constellation": "Sge",
    "ra_deg": 298.4437083333333,
    "dec_deg": 18.779194444444443,
    "ra_hms": "19:53:46.49",
    "dec_dms": "+18:46:45.1"
  },
  "M72": {
    "id": "M72",
    "name": "M72",
    "type": "Globular Cluster",
    "constellation": "Aqr",
    "ra_deg": 313.3654166666666,
    "dec_deg": -12.537305555555555,
    "ra_hms": "20:53:27.70",
    "dec_dms": "-12:32:14.3"
  },
  "M75": {
    "id": "M75",
    "name": "M75",
    "type": "Globular Cluster",
    "constellation": "Sgr",
    "ra_deg": 301.5201708333333,
    "dec_deg": -21.922261111111112,
    "ra_hms": "20:06:04.84",
    "dec_dms": "-21:55:20.1"
  },
  "M76": {
    "id": "M76",
    "name": "Little Dumbbell Nebula",
    "type": "Planetary Nebula",
    "constellation": "Per",
    "ra_deg": 25.581899053419995,
    "dec_deg": 51.57542638057,
    "ra_hms": "01:42:19.66",
    "dec_dms": "+51:34:31.5"
  },
  "M78": {
    "id": "M78",
    "name": "M78",
    "type": "Reflection Nebula",
    "constellation": "Ori",
    "ra_deg": 86.69083333333332,
    "dec_deg": 0.07916666666666666,
    "ra_hms": "05:46:45.80",
    "dec_dms": "+00:04:45.0"
  },
  "M79": {
    "id": "M79",
    "name": "M79",
    "type": "Globular Cluster",
    "constellation": "Lep",
    "ra_deg": 81.044125,
    "dec_deg": -24.52425,
    "ra_hms": "05:24:10.59",
    "dec_dms": "-24:31:27.3"
  },
  "M80": {
    "id": "M80",
    "name": "M80",
    "type": "Globular Cluster",
    "constellation": "Sco",
    "ra_deg": 244.26004166666667,
    "dec_deg": -22.97608333333333,
    "ra_hms": "16:17:02.41",
    "dec_dms": "-22:58:33.9"
  },
  "M81": {
    "id": "M81",
    "name": "Bode's Galaxy",
    "type": "Seyfert 2 Galaxy",
    "constellation": "UMa",
    "ra_deg": 148.88821939853997,
    "dec_deg": 69.06529514038,
    "ra_hms": "09:55:33.17",
    "dec_dms": "+69:03:55.1"
  },
  "M82": {
    "id": "M82",
    "name": "Cigar Galaxy",
    "type": "Active Galactic Nuclei",
    "constellation": "UMa",
    "ra_deg": 148.9684583333333,
    "dec_deg": 69.67970277777778,
    "ra_hms": "09:55:52.43",
    "dec_dms": "+69:40:46.9"
  },
  "M92": {
    "id": "M92",
    "name": "M92",
    "type": "Globular Cluster",
    "constellation": "Her",
    "ra_deg": 259.28079166666663,
    "dec_deg": 43.13594444444444,
    "ra_hms": "17:17:07.39",
    "dec_dms": "+43:08:09.4"
  },
  "M93": {
    "id": "M93",
    "name": "Critter Cluster",
    "type": "Open Cluster",
    "constellation": "Pup",
    "ra_deg": 116.14083333333332,
    "dec_deg": -23.853055555555557,
    "ra_hms": "07:44:33.80",
    "dec_dms": "-23:51:11.0"
  },
  "M94": {
    "id": "M94",
    "name": "Cat's Eye Galaxy",
    "type": "Seyfert Galaxy",
    "constellation": "CVn",
    "ra_deg": 192.72114082142997,
    "dec_deg": 41.12025024573,
    "ra_hms": "12:50:53.07",
    "dec_dms": "+41:07:12.9"
  },
  "M97": {
    "id": "M97",
    "name": "Owl Nebula",
    "type": "Planetary Nebula",
    "constellation": "UMa",
    "ra_deg": 168.69880122824998,
    "dec_deg": 55.01902300891,
    "ra_hms": "11:14:47.71",
    "dec_dms": "+55:01:08.5"
  },
  "M101": {
    "id": "M101",
    "name": "Pinwheel Galaxy",
    "type": "Galaxy",
    "constellation": "UMa",
    "ra_deg": 210.80242916666666,
    "dec_deg": 54.34875,
    "ra_hms": "14:03:12.58",
    "dec_dms": "+54:20:55.5"
  },
  "M103": {
    "id": "M103",
    "name": "M103",
    "type": "Open Cluster",
    "constellation": "Cas",
    "ra_deg": 23.339166666666667,
    "dec_deg": 60.65888888888889,
    "ra_hms": "01:33:21.40",
    "dec_dms": "+60:39:32.0"
  },
  "M104": {
    "id": "M104",
    "name": "Sombrero Galaxy",
    "type": "Active Galactic Nuclei",
    "constellation": "Vir",
    "ra_deg": 189.99763274591666,
    "dec_deg": -11.623054494444444,
    "ra_hms": "12:39:59.43",
    "dec_dms": "-11:37:23.0"
  },
  "M106": {
    "id": "M106",
    "name": "M106",
    "type": "Seyfert 2 Galaxy",
    "constellation": "CVn",
    "ra_deg": 184.7400833333333,
    "dec_deg": 47.30371944444444,
    "ra_hms": "12:18:57.62",
    "dec_dms": "+47:18:13.4"
  },
  "M107": {
    "id": "M107",
    "name": "Crucifix Cluster",
    "type": "Globular Cluster",
    "constellation": "Oph",
    "ra_deg": 248.13275,
    "dec_deg": -13.053777777777778,
    "ra_hms": "16:32:31.86",
    "dec_dms": "-13:03:13.6"
  },
  "M108": {
    "id": "M108",
    "name": "Surfboard Galaxy",
    "type": "Starburst Galaxy",
    "constellation": "UMa",
    "ra_deg": 167.87902916666667,
    "dec_deg": 55.67412222222222,
    "ra_hms": "11:11:30.97",
    "dec_dms": "+55:40:26.8"
  },
  "M109": {
    "id": "M109",
    "name": "Vacuum Cleaner Galaxy",
    "type": "Galaxy",
    "constellation": "UMa",
    "ra_deg": 179.39984644984995,
    "dec_deg": 53.37472391176,
    "ra_hms": "11:57:35.96",
    "dec_dms": "+53:22:29.0"
  },
  "M110": {
    "id": "M110",
    "name": "M110",
    "type": "Galaxy",
    "constellation": "And",
    "ra_deg": 10.091905145829998,
    "dec_deg": 41.68541867226,
    "ra_hms": "00:40:22.06",
    "dec_dms": "+41:41:07.5"
  },
  "NGC7000": {
    "id": "NGC7000",
    "name": "North American Nebula",
    "type": "Emission Nebula",
    "constellation": "Cyg",
    "ra_deg": 314.69583333333327,
    "dec_deg": 44.330000000000005,
    "ra_hms": "20:58:47.00",
    "dec_dms": "+44:19:48.0"
  },
  "NGC6960": {
    "id": "NGC6960",
    "name": "Veil Nebula",
    "type": "Supernova Remnant",
    "constellation": "Cyg",
    "ra_deg": 311.4083333333333,
    "dec_deg": 30.708333333333332,
    "ra_hms": "20:45:38.00",
    "dec_dms": "+30:42:30.0"
  },
  "NGC869": {
    "id": "NGC869",
    "name": "Double Cluster",
    "type": "Open Cluster",
    "constellation": "Per",
    "ra_deg": 34.74083333333333,
    "dec_deg": 57.13388888888889,
    "ra_hms": "02:18:57.80",
    "dec_dms": "+57:08:02.0"
  },
  "NGC884": {
    "id": "NGC884",
    "name": "Double Cluster",
    "type": "Open Cluster",
    "constellation": "Per",
    "ra_deg": 35.58416666666666,
    "dec_deg": 57.14888888888889,
    "ra_hms": "02:22:20.20",
    "dec_dms": "+57:08:56.0"
  },
  "NGC6826": {
    "id": "NGC6826",
    "name": "Blinking Planetary Nebula",
    "type": "Planetary Nebula",
    "constellation": "Cyg",
    "ra_deg": 296.20062509411997,
    "dec_deg": 50.525069176369996,
    "ra_hms": "19:44:48.15",
    "dec_dms": "+50:31:30.2"
  },
  "NGC6543": {
    "id": "NGC6543",
    "name": "Cat's Eye Nebula",
    "type": "Planetary Nebula",
    "constellation": "Dra",
    "ra_deg": 269.63918316136994,
    "dec_deg": 66.632986315,
    "ra_hms": "17:58:33.40",
    "dec_dms": "+66:37:58.8"
  },
  "NGC891": {
    "id": "NGC891",
    "name": "Outer Limits Galaxy",
    "type": "HII Galaxy",
    "constellation": "And",
    "ra_deg": 35.63711249999999,
    "dec_deg": 42.34831944444445,
    "ra_hms": "02:22:32.91",
    "dec_dms": "+42:20:54.0"
  },
  "M8": {
    "id": "M8",
    "name": "Lagoon Nebula",
    "type": "Open Cluster",
    "constellation": "Sgr",
    "ra_deg": 270.90416666666664,
    "dec_deg": -24.386666666666667,
    "ra_hms": "18:03:37.00",
    "dec_dms": "-24:23:12.0"
  },
  "M17": {
    "id": "M17",
    "name": "Swan Nebula",
    "type": "Open Cluster",
    "constellation": "Sgr",
    "ra_deg": 274.81249999999994,
    "dec_deg": -16.583333333333332,
    "ra_hms": "18:19:15.00",
    "dec_dms": "-16:35:00.0"
  },
  "M49": {
    "id": "M49",
    "name": "M49",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Vir",
    "ra_deg": 187.44499999999996,
    "dec_deg": 8.000277777777777,
    "ra_hms": "12:29:46.80",
    "dec_dms": "+08:00:01.0"
  },
  "M59": {
    "id": "M59",
    "name": "M59",
    "type": "Galaxy",
    "constellation": "Vir",
    "ra_deg": 190.50940890631998,
    "dec_deg": 11.64691930771,
    "ra_hms": "12:42:02.26",
    "dec_dms": "+11:38:48.9"
  },
  "M60": {
    "id": "M60",
    "name": "M60",
    "type": "Galaxy",
    "constellation": "Vir",
    "ra_deg": 190.91653333333332,
    "dec_deg": 11.552693333333334,
    "ra_hms": "12:43:39.97",
    "dec_dms": "+11:33:09.7"
  },
  "M61": {
    "id": "M61",
    "name": "M61",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Vir",
    "ra_deg": 185.47886774286997,
    "dec_deg": 4.47377704644,
    "ra_hms": "12:21:54.93",
    "dec_dms": "+04:28:25.6"
  },
  "M65": {
    "id": "M65",
    "name": "M65",
    "type": "Galaxy in a Triplet",
    "constellation": "Leo",
    "ra_deg": 169.73295193949,
    "dec_deg": 13.092305751020001,
    "ra_hms": "11:18:55.91",
    "dec_dms": "+13:05:32.3"
  },
  "M66": {
    "id": "M66",
    "name": "M66",
    "type": "Galaxy in a Triplet",
    "constellation": "Leo",
    "ra_deg": 170.06249999999997,
    "dec_deg": 12.991388888888888,
    "ra_hms": "11:20:15.00",
    "dec_dms": "+12:59:29.0"
  },
  "M74": {
    "id": "M74",
    "name": "Phantom Galaxy",
    "type": "Galaxy",
    "constellation": "Psc",
    "ra_deg": 24.17393801526,
    "dec_deg": 15.78364097564,
    "ra_hms": "01:36:41.75",
    "dec_dms": "+15:47:01.1"
  },
  "M77": {
    "id": "M77",
    "name": "M77",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Cet",
    "ra_deg": 40.66962152892,
    "dec_deg": -0.01329435839,
    "ra_hms": "02:42:40.71",
    "dec_dms": "-00:00:47.9"
  },
  "M83": {
    "id": "M83",
    "name": "Southern Pinwheel Galaxy",
    "type": "Starburst Galaxy",
    "constellation": "Hya",
    "ra_deg": 204.25383,
    "dec_deg": -29.865761111111112,
    "ra_hms": "13:37:00.92",
    "dec_dms": "-29:51:56.7"
  },
  "M84": {
    "id": "M84",
    "name": "M84",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Vir",
    "ra_deg": 186.2655972083333,
    "dec_deg": 12.886983138888889,
    "ra_hms": "12:25:03.74",
    "dec_dms": "+12:53:13.1"
  },
  "M85": {
    "id": "M85",
    "name": "M85",
    "type": "Galaxy",
    "constellation": "Com",
    "ra_deg": 186.3502208333333,
    "dec_deg": 18.191080555555555,
    "ra_hms": "12:25:24.05",
    "dec_dms": "+18:11:27.9"
  },
  "M86": {
    "id": "M86",
    "name": "M86",
    "type": "Galaxy",
    "constellation": "Vir",
    "ra_deg": 186.54922499999998,
    "dec_deg": 12.945969444444446,
    "ra_hms": "12:26:11.81",
    "dec_dms": "+12:56:45.5"
  },
  "M87": {
    "id": "M87",
    "name": "Virgo A",
    "type": "Active Galactic Nuclei",
    "constellation": "Vir",
    "ra_deg": 187.70593076724998,
    "dec_deg": 12.391123246083334,
    "ra_hms": "12:30:49.42",
    "dec_dms": "+12:23:28.0"
  },
  "M89": {
    "id": "M89",
    "name": "M89",
    "type": "Active Galactic Nuclei",
    "constellation": "Vir",
    "ra_deg": 188.91586388929164,
    "dec_deg": 12.55634190713889,
    "ra_hms": "12:35:39.81",
    "dec_dms": "+12:33:22.8"
  },
  "M90": {
    "id": "M90",
    "name": "M90",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Vir",
    "ra_deg": 189.20750409994997,
    "dec_deg": 13.162923281400001,
    "ra_hms": "12:36:49.80",
    "dec_dms": "+13:09:46.5"
  },
  "M91": {
    "id": "M91",
    "name": "M91",
    "type": "Active Galactic Nuclei",
    "constellation": "Com",
    "ra_deg": 188.86018615054996,
    "dec_deg": 14.49632231493,
    "ra_hms": "12:35:26.44",
    "dec_dms": "+14:29:46.8"
  },
  "M95": {
    "id": "M95",
    "name": "M95",
    "type": "Galaxy",
    "constellation": "Leo",
    "ra_deg": 160.99054728574998,
    "dec_deg": 11.70369477537,
    "ra_hms": "10:43:57.73",
    "dec_dms": "+11:42:13.3"
  },
  "M96": {
    "id": "M96",
    "name": "M96",
    "type": "Galaxy",
    "constellation": "Leo",
    "ra_deg": 161.6906,
    "dec_deg": 11.819938888888888,
    "ra_hms": "10:46:45.74",
    "dec_dms": "+11:49:11.8"
  },
  "M99": {
    "id": "M99",
    "name": "St. Catherine's Wheel",
    "type": "HII Galaxy",
    "constellation": "Com",
    "ra_deg": 184.70677083333334,
    "dec_deg": 14.416488888888889,
    "ra_hms": "12:18:49.63",
    "dec_dms": "+14:24:59.4"
  },
  "M100": {
    "id": "M100",
    "name": "Mirror Galaxy",
    "type": "Active Galactic Nuclei",
    "constellation": "Com",
    "ra_deg": 185.72887499733,
    "dec_deg": 15.822304516099999,
    "ra_hms": "12:22:54.93",
    "dec_dms": "+15:49:20.3"
  },
  "M102": {
    "id": "M102",
    "name": "Spindle Galaxy",
    "type": "Seyfert Galaxy",
    "constellation": "Dra",
    "ra_deg": 226.6231708333333,
    "dec_deg": 55.763308333333335,
    "ra_hms": "15:06:29.56",
    "dec_dms": "+55:45:47.9"
  },
  "M105": {
    "id": "M105",
    "name": "M105",
    "type": "Active Galactic Nuclei",
    "constellation": "Leo",
    "ra_deg": 161.95666666666665,
    "dec_deg": 12.581630555555556,
    "ra_hms": "10:47:49.60",
    "dec_dms": "+12:34:53.9"
  },
  "NGC281": {
    "id": "NGC281",
    "name": "NGC281",
    "type": "HII Region",
    "constellation": "Cas",
    "ra_deg": 13.104583333333332,
    "dec_deg": 56.565,
    "ra_hms": "00:52:25.10",
    "dec_dms": "+56:33:54.0"
  },
  "NGC457": {
    "id": "NGC457",
    "name": "NGC457",
    "type": "Open Cluster",
    "constellation": "Cas",
    "ra_deg": 19.88708333333333,
    "dec_deg": 58.278055555555554,
    "ra_hms": "01:19:32.90",
    "dec_dms": "+58:16:41.0"
  },
  "NGC604": {
    "id": "NGC604",
    "name": "NGC604",
    "type": "HII Region",
    "constellation": "Tri",
    "ra_deg": 23.633749999999996,
    "dec_deg": 30.783611111111114,
    "ra_hms": "01:34:32.10",
    "dec_dms": "+30:47:01.0"
  },
  "NGC1073": {
    "id": "NGC1073",
    "name": "NGC1073",
    "type": "Emission-line galaxy",
    "constellation": "Cet",
    "ra_deg": 40.91915833333333,
    "dec_deg": 1.3758694444444444,
    "ra_hms": "02:43:40.60",
    "dec_dms": "+01:22:33.1"
  },
  "NGC1275": {
    "id": "NGC1275",
    "name": "Perseus A",
    "type": "Seyfert 1.5 Galaxy",
    "constellation": "Per",
    "ra_deg": 49.95066662584999,
    "dec_deg": 41.51169690301,
    "ra_hms": "03:19:48.16",
    "dec_dms": "+41:30:42.1"
  },
  "NGC1952": {
    "id": "NGC1952",
    "name": "Crab Nebula",
    "type": "SuperNova Remnant",
    "constellation": "Tau",
    "ra_deg": 83.6325,
    "dec_deg": 22.0175,
    "ra_hms": "05:34:31.80",
    "dec_dms": "+22:01:03.0"
  },
  "NGC2070": {
    "id": "NGC2070",
    "name": "Tarantula Nebula",
    "type": "Cluster of Stars",
    "constellation": "Dor",
    "ra_deg": 84.67499999999998,
    "dec_deg": -69.1,
    "ra_hms": "05:38:42.00",
    "dec_dms": "-69:06:00.0"
  },
  "NGC2237": {
    "id": "NGC2237",
    "name": "Rosette Nebula",
    "type": "Cluster of Stars",
    "constellation": "Mon",
    "ra_deg": 97.65041666666666,
    "dec_deg": 4.980722222222222,
    "ra_hms": "06:30:36.10",
    "dec_dms": "+04:58:50.6"
  },
  "NGC2359": {
    "id": "NGC2359",
    "name": "Thor's Helmet",
    "type": "HII Region",
    "constellation": "CMa",
    "ra_deg": 109.62499999999999,
    "dec_deg": -13.226666666666667,
    "ra_hms": "07:18:30.00",
    "dec_dms": "-13:13:36.0"
  },
  "NGC2438": {
    "id": "NGC2438",
    "name": "NGC2438",
    "type": "Planetary Nebula",
    "constellation": "Pup",
    "ra_deg": 115.46049760579,
    "dec_deg": -14.735408373539999,
    "ra_hms": "07:41:50.52",
    "dec_dms": "-14:44:07.5"
  },
  "NGC2440": {
    "id": "NGC2440",
    "name": "NGC2440",
    "type": "Planetary Nebula",
    "constellation": "Pup",
    "ra_deg": 115.48083333333332,
    "dec_deg": -18.20888888888889,
    "ra_hms": "07:41:55.40",
    "dec_dms": "-18:12:32.0"
  },
  "IC1805": {
    "id": "IC1805",
    "name": "Collinder 26",
    "type": "Open Cluster",
    "constellation": "Cas",
    "ra_deg": 38.209999999999994,
    "dec_deg": 61.471111111111114,
    "ra_hms": "02:32:50.40",
    "dec_dms": "+61:28:16.0"
  },
  "IC2391": {
    "id": "IC2391",
    "name": "Omicron Velorum Cluster",
    "type": "Open Cluster",
    "constellation": "Vel",
    "ra_deg": 130.29208333333332,
    "dec_deg": -52.99111111111111,
    "ra_hms": "08:41:10.10",
    "dec_dms": "-52:59:28.0"
  },
  "IC2574": {
    "id": "IC2574",
    "name": "Coddington's Nebula",
    "type": "Dwarf Galaxy",
    "constellation": "UMa",
    "ra_deg": 157.09839534641998,
    "dec_deg": 68.41206667021001,
    "ra_hms": "10:28:23.61",
    "dec_dms": "+68:24:43.4"
  },
  "IC2602": {
    "id": "IC2602",
    "name": "Southern Pleiades",
    "type": "Open Cluster",
    "constellation": "Car",
    "ra_deg": 160.61291666666665,
    "dec_deg": -64.42611111111111,
    "ra_hms": "10:42:27.10",
    "dec_dms": "-64:25:34.0"
  },
  "IC342": {
    "id": "IC342",
    "name": "IC 342",
    "type": "Starburst Galaxy",
    "constellation": "Cam",
    "ra_deg": 56.70214166666666,
    "dec_deg": 68.09610555555555,
    "ra_hms": "03:46:48.51",
    "dec_dms": "+68:05:46.0"
  },
  "LMC": {
    "id": "LMC",
    "name": "Large Magellanic Cloud",
    "type": "Galaxy",
    "constellation": "Dor",
    "ra_deg": 80.89416666666666,
    "dec_deg": -69.75611111111111,
    "ra_hms": "05:23:34.60",
    "dec_dms": "-69:45:22.0"
  },
  "NGC104": {
    "id": "NGC104",
    "name": "47 Tucanae",
    "type": "Globular Cluster",
    "constellation": "Tuc",
    "ra_deg": 6.022329166666666,
    "dec_deg": -72.08144444444444,
    "ra_hms": "00:24:05.36",
    "dec_dms": "-72:04:53.2"
  },
  "NGC1499": {
    "id": "NGC1499",
    "name": "California Nebula",
    "type": "HII Region",
    "constellation": "Per",
    "ra_deg": 59.77649999999999,
    "dec_deg": 36.55833333333333,
    "ra_hms": "03:59:06.36",
    "dec_dms": "+36:33:30.0"
  },
  "NGC1851": {
    "id": "NGC1851",
    "name": "Caldwell 73",
    "type": "Globular Cluster",
    "constellation": "Col",
    "ra_deg": 78.52816666666665,
    "dec_deg": -40.04655555555556,
    "ra_hms": "05:14:06.76",
    "dec_dms": "-40:02:47.6"
  },
  "NGC188": {
    "id": "NGC188",
    "name": "Caldwell 1",
    "type": "Open Cluster",
    "constellation": "Cep",
    "ra_deg": 11.797916666666666,
    "dec_deg": 85.24388888888889,
    "ra_hms": "00:47:11.50",
    "dec_dms": "+85:14:38.0"
  },
  "NGC1931": {
    "id": "NGC1931",
    "name": "NGC1931",
    "type": "Open Cluster",
    "constellation": "Aur",
    "ra_deg": 82.84499999999998,
    "dec_deg": 34.23305555555556,
    "ra_hms": "05:31:22.80",
    "dec_dms": "+34:13:59.0"
  },
  "NGC2169": {
    "id": "NGC2169",
    "name": "The 37 Cluster",
    "type": "Open Cluster",
    "constellation": "Ori",
    "ra_deg": 92.125,
    "dec_deg": 13.95111111111111,
    "ra_hms": "06:08:30.00",
    "dec_dms": "+13:57:04.0"
  },
  "NGC2261": {
    "id": "NGC2261",
    "name": "Hubble's Variable Nebula",
    "type": "Herbig Ae/Be Star",
    "constellation": "Mon",
    "ra_deg": 99.79147583352,
    "dec_deg": 8.735983189619999,
    "ra_hms": "06:39:09.95",
    "dec_dms": "+08:44:09.5"
  },
  "NGC2264": {
    "id": "NGC2264",
    "name": "Christmas Tree Cluster",
    "type": "Open Cluster",
    "constellation": "Mon",
    "ra_deg": 100.21708333333333,
    "dec_deg": 9.876944444444446,
    "ra_hms": "06:40:52.10",
    "dec_dms": "+09:52:37.0"
  },
  "NGC2301": {
    "id": "NGC2301",
    "name": "NGC2301",
    "type": "Open Cluster",
    "constellation": "Mon",
    "ra_deg": 102.94291666666665,
    "dec_deg": 0.465,
    "ra_hms": "06:51:46.30",
    "dec_dms": "+00:27:54.0"
  },
  "NGC2362": {
    "id": "NGC2362",
    "name": "NGC2362",
    "type": "Open Cluster",
    "constellation": "CMa",
    "ra_deg": 109.67083333333332,
    "dec_deg": -24.953888888888887,
    "ra_hms": "07:18:41.00",
    "dec_dms": "-24:57:14.0"
  },
  "NGC2392": {
    "id": "NGC2392",
    "name": "Eskimo Nebula",
    "type": "Planetary Nebula",
    "constellation": "Gem",
    "ra_deg": 112.29486308253999,
    "dec_deg": 20.911798580019997,
    "ra_hms": "07:29:10.77",
    "dec_dms": "+20:54:42.5"
  },
  "NGC2403": {
    "id": "NGC2403",
    "name": "NGC2403",
    "type": "Active Galactic Nuclei",
    "constellation": "Cam",
    "ra_deg": 114.21390893094997,
    "dec_deg": 65.60268078489999,
    "ra_hms": "07:36:51.34",
    "dec_dms": "+65:36:09.7"
  },
  "NGC2419": {
    "id": "NGC2419",
    "name": "Intergalactic Wanderer",
    "type": "Globular Cluster",
    "constellation": "Lyn",
    "ra_deg": 114.53545833333331,
    "dec_deg": 38.88191666666667,
    "ra_hms": "07:38:08.51",
    "dec_dms": "+38:52:54.9"
  },
  "NGC2451": {
    "id": "NGC2451",
    "name": "NGC2451",
    "type": "Cluster of Stars",
    "constellation": "Pup",
    "ra_deg": 116.35,
    "dec_deg": -37.96666666666667,
    "ra_hms": "07:45:24.00",
    "dec_dms": "-37:58:00.0"
  },
  "NGC2477": {
    "id": "NGC2477",
    "name": "Termite Hole Cluster",
    "type": "Open Cluster",
    "constellation": "Pup",
    "ra_deg": 118.04583333333332,
    "dec_deg": -38.536944444444444,
    "ra_hms": "07:52:11.00",
    "dec_dms": "-38:32:13.0"
  },
  "NGC2516": {
    "id": "NGC2516",
    "name": "Southern Beehive Cluster",
    "type": "Open Cluster",
    "constellation": "Car",
    "ra_deg": 119.52708333333332,
    "dec_deg": -60.8,
    "ra_hms": "07:58:06.50",
    "dec_dms": "-60:48:00.0"
  },
  "NGC2683": {
    "id": "NGC2683",
    "name": "UFO Galaxy",
    "type": "Active Galactic Nuclei",
    "constellation": "Lyn",
    "ra_deg": 133.17211034566,
    "dec_deg": 33.421832689309994,
    "ra_hms": "08:52:41.31",
    "dec_dms": "+33:25:18.6"
  },
  "NGC2841": {
    "id": "NGC2841",
    "name": "NGC2841",
    "type": "Active Galactic Nuclei",
    "constellation": "UMa",
    "ra_deg": 140.51115779653998,
    "dec_deg": 50.976593634130005,
    "ra_hms": "09:22:02.68",
    "dec_dms": "+50:58:35.7"
  },
  "NGC288": {
    "id": "NGC288",
    "name": "NGC288",
    "type": "Globular Cluster",
    "constellation": "Scl",
    "ra_deg": 13.188499999999998,
    "dec_deg": -26.58261111111111,
    "ra_hms": "00:52:45.24",
    "dec_dms": "-26:34:57.4"
  },
  "NGC300": {
    "id": "NGC300",
    "name": "Sculptor Pinwheel Galaxy",
    "type": "Galaxy",
    "constellation": "Scl",
    "ra_deg": 13.722694015959998,
    "dec_deg": -37.68421344511,
    "ra_hms": "00:54:53.45",
    "dec_dms": "-37:41:03.2"
  },
  "NGC3132": {
    "id": "NGC3132",
    "name": "Southern Ring Nebula",
    "type": "Planetary Nebula",
    "constellation": "Vel",
    "ra_deg": 151.75735684270998,
    "dec_deg": -40.43642515362,
    "ra_hms": "10:07:01.77",
    "dec_dms": "-40:26:11.1"
  },
  "NGC3184": {
    "id": "NGC3184",
    "name": "Little Pinwheel Galaxy",
    "type": "Galaxy",
    "constellation": "UMa",
    "ra_deg": 154.5707708333333,
    "dec_deg": 41.42438055555555,
    "ra_hms": "10:18:16.99",
    "dec_dms": "+41:25:27.8"
  },
  "NGC3293": {
    "id": "NGC3293",
    "name": "NGC3293",
    "type": "Open Cluster",
    "constellation": "Car",
    "ra_deg": 158.97,
    "dec_deg": -58.23111111111111,
    "ra_hms": "10:35:52.80",
    "dec_dms": "-58:13:52.0"
  },
  "NGC3310": {
    "id": "NGC3310",
    "name": "NGC3310",
    "type": "Active Galactic Nuclei",
    "constellation": "UMa",
    "ra_deg": 159.69107112499998,
    "dec_deg": 53.50330388888889,
    "ra_hms": "10:38:45.86",
    "dec_dms": "+53:30:11.9"
  },
  "NGC3372": {
    "id": "NGC3372",
    "name": "Carina Nebula",
    "type": "HII Region",
    "constellation": "Car",
    "ra_deg": 161.25929166666666,
    "dec_deg": -59.69994444444444,
    "ra_hms": "10:45:02.23",
    "dec_dms": "-59:41:59.8"
  },
  "NGC3521": {
    "id": "NGC3521",
    "name": "NGC3521",
    "type": "Galaxy",
    "constellation": "Leo",
    "ra_deg": 166.45236707974,
    "dec_deg": -0.03590141015,
    "ra_hms": "11:05:48.57",
    "dec_dms": "-00:02:09.2"
  },
  "NGC3532": {
    "id": "NGC3532",
    "name": "Wishing Well Cluster",
    "type": "Open Cluster",
    "constellation": "Car",
    "ra_deg": 166.41708333333332,
    "dec_deg": -58.706944444444446,
    "ra_hms": "11:05:40.10",
    "dec_dms": "-58:42:25.0"
  },
  "NGC3576": {
    "id": "NGC3576",
    "name": "Statue of Liberty Nebula",
    "type": "HII Region",
    "constellation": "Car",
    "ra_deg": 167.97166666666664,
    "dec_deg": -61.30722222222222,
    "ra_hms": "11:11:53.20",
    "dec_dms": "-61:18:26.0"
  },
  "NGC3603": {
    "id": "NGC3603",
    "name": "NGC3603",
    "type": "Open Cluster",
    "constellation": "Car",
    "ra_deg": 168.74124999999995,
    "dec_deg": -61.242222222222225,
    "ra_hms": "11:14:57.90",
    "dec_dms": "-61:14:32.0"
  },
  "NGC362": {
    "id": "NGC362",
    "name": "Caldwell 104",
    "type": "Globular Cluster",
    "constellation": "Tuc",
    "ra_deg": 15.809416666666666,
    "dec_deg": -70.84877777777777,
    "ra_hms": "01:03:14.26",
    "dec_dms": "-70:50:55.6"
  },
  "NGC3628": {
    "id": "NGC3628",
    "name": "Hamburger Galaxy",
    "type": "Galaxy",
    "constellation": "Leo",
    "ra_deg": 170.0709083333333,
    "dec_deg": 13.589488888888889,
    "ra_hms": "11:20:17.02",
    "dec_dms": "+13:35:22.2"
  },
  "NGC3766": {
    "id": "NGC3766",
    "name": "Caldwell 97",
    "type": "Open Cluster",
    "constellation": "Cen",
    "ra_deg": 174.0608333333333,
    "dec_deg": -61.61611111111111,
    "ra_hms": "11:36:14.60",
    "dec_dms": "-61:36:58.0"
  },
  "NGC4038": {
    "id": "NGC4038",
    "name": "Antennae Galaxies",
    "type": "Emission-line galaxy",
    "constellation": "Crv",
    "ra_deg": 180.47084166666664,
    "dec_deg": -18.86758888888889,
    "ra_hms": "12:01:53.00",
    "dec_dms": "-18:52:03.3"
  },
  "NGC4039": {
    "id": "NGC4039",
    "name": "Antennae Galaxies",
    "type": "Galaxy",
    "constellation": "Crv",
    "ra_deg": 180.47295833333334,
    "dec_deg": -18.886194444444445,
    "ra_hms": "12:01:53.51",
    "dec_dms": "-18:53:10.3"
  },
  "NGC404": {
    "id": "NGC404",
    "name": "NGC404",
    "type": "Active Galactic Nuclei",
    "constellation": "And",
    "ra_deg": 17.36258333333333,
    "dec_deg": 35.71813888888889,
    "ra_hms": "01:09:27.02",
    "dec_dms": "+35:43:05.3"
  },
  "NGC4147": {
    "id": "NGC4147",
    "name": "NGC4147",
    "type": "Globular Cluster",
    "constellation": "Com",
    "ra_deg": 182.5256208333333,
    "dec_deg": 18.542161111111113,
    "ra_hms": "12:10:06.15",
    "dec_dms": "+18:32:31.8"
  },
  "NGC4244": {
    "id": "NGC4244",
    "name": "NGC4244",
    "type": "Galaxy",
    "constellation": "CVn",
    "ra_deg": 184.37357916666664,
    "dec_deg": 37.807111111111105,
    "ra_hms": "12:17:29.66",
    "dec_dms": "+37:48:25.6"
  },
  "NGC4449": {
    "id": "NGC4449",
    "name": "NGC4449",
    "type": "Emission-line galaxy",
    "constellation": "CVn",
    "ra_deg": 187.04632499999997,
    "dec_deg": 44.093558333333334,
    "ra_hms": "12:28:11.12",
    "dec_dms": "+44:05:36.8"
  },
  "NGC4565": {
    "id": "NGC4565",
    "name": "Needle Galaxy",
    "type": "Active Galactic Nuclei",
    "constellation": "Com",
    "ra_deg": 189.0866833333333,
    "dec_deg": 25.987391666666667,
    "ra_hms": "12:36:20.80",
    "dec_dms": "+25:59:14.6"
  },
  "NGC4631": {
    "id": "NGC4631",
    "name": "Whale Galaxy",
    "type": "Galaxy",
    "constellation": "CVn",
    "ra_deg": 190.5333708333333,
    "dec_deg": 32.541511111111106,
    "ra_hms": "12:42:08.01",
    "dec_dms": "+32:32:29.4"
  },
  "NGC4656": {
    "id": "NGC4656",
    "name": "Hockey Stick Galaxy",
    "type": "Galaxy",
    "constellation": "CVn",
    "ra_deg": 190.99037045407,
    "dec_deg": 32.17037386514,
    "ra_hms": "12:43:57.69",
    "dec_dms": "+32:10:13.3"
  },
  "NGC4725": {
    "id": "NGC4725",
    "name": "NGC4725",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Com",
    "ra_deg": 192.61071515332998,
    "dec_deg": 25.50075919183,
    "ra_hms": "12:50:26.57",
    "dec_dms": "+25:30:02.7"
  },
  "NGC4755": {
    "id": "NGC4755",
    "name": "The Jewel Box",
    "type": "Open Cluster",
    "constellation": "Cru",
    "ra_deg": 193.41499999999996,
    "dec_deg": -60.37111111111111,
    "ra_hms": "12:53:39.60",
    "dec_dms": "-60:22:16.0"
  },
  "NGC4945": {
    "id": "NGC4945",
    "name": "NGC4945",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Cen",
    "ra_deg": 196.36366249999998,
    "dec_deg": -49.4679,
    "ra_hms": "13:05:27.28",
    "dec_dms": "-49:28:04.4"
  },
  "NGC5053": {
    "id": "NGC5053",
    "name": "NGC5053",
    "type": "Globular Cluster",
    "constellation": "Com",
    "ra_deg": 199.11287499999997,
    "dec_deg": 17.70025,
    "ra_hms": "13:16:27.09",
    "dec_dms": "+17:42:00.9"
  },
  "NGC5128": {
    "id": "NGC5128",
    "name": "Centaurus A",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Cen",
    "ra_deg": 201.3650633768333,
    "dec_deg": -43.01911250808333,
    "ra_hms": "13:25:27.62",
    "dec_dms": "-43:01:08.8"
  },
  "NGC5139": {
    "id": "NGC5139",
    "name": "Omega Centauri",
    "type": "Globular Cluster",
    "constellation": "Cen",
    "ra_deg": 201.697,
    "dec_deg": -47.47947222222223,
    "ra_hms": "13:26:47.28",
    "dec_dms": "-47:28:46.1"
  },
  "NGC5466": {
    "id": "NGC5466",
    "name": "NGC5466",
    "type": "Globular Cluster",
    "constellation": "Boo",
    "ra_deg": 211.36370833333334,
    "dec_deg": 28.534444444444446,
    "ra_hms": "14:05:27.29",
    "dec_dms": "+28:32:04.0"
  },
  "NGC5746": {
    "id": "NGC5746",
    "name": "Mini Sombrero Galaxy",
    "type": "Galaxy",
    "constellation": "Vir",
    "ra_deg": 221.23335416666663,
    "dec_deg": 1.9547388888888888,
    "ra_hms": "14:44:56.01",
    "dec_dms": "+01:57:17.1"
  },
  "NGC5822": {
    "id": "NGC5822",
    "name": "NGC5822",
    "type": "Open Cluster",
    "constellation": "Lup",
    "ra_deg": 226.05083333333332,
    "dec_deg": -54.36611111111111,
    "ra_hms": "15:04:12.20",
    "dec_dms": "-54:21:58.0"
  },
  "NGC5897": {
    "id": "NGC5897",
    "name": "NGC5897",
    "type": "Globular Cluster",
    "constellation": "Lib",
    "ra_deg": 229.35166666666663,
    "dec_deg": -21.01011111111111,
    "ra_hms": "15:17:24.40",
    "dec_dms": "-21:00:36.4"
  },
  "NGC6164": {
    "id": "NGC6164",
    "name": "Dragon's Egg Nebula",
    "type": "Emission Nebula",
    "constellation": "Nor",
    "ra_deg": 248.4682788273,
    "dec_deg": -48.111243449650004,
    "ra_hms": "16:33:52.39",
    "dec_dms": "-48:06:40.5"
  },
  "NGC6188": {
    "id": "NGC6188",
    "name": "Firebird Nebula",
    "type": "Emission Nebula",
    "constellation": "Ara",
    "ra_deg": 250.0,
    "dec_deg": -48.5,
    "ra_hms": "16:40:00.00",
    "dec_dms": "-48:30:00.0"
  },
  "NGC6229": {
    "id": "NGC6229",
    "name": "NGC6229",
    "type": "Globular Cluster",
    "constellation": "Her",
    "ra_deg": 251.74433749999994,
    "dec_deg": 47.52677222222222,
    "ra_hms": "16:46:58.64",
    "dec_dms": "+47:31:36.4"
  },
  "NGC6231": {
    "id": "NGC6231",
    "name": "Baby Scorpion Cluster",
    "type": "Open Cluster",
    "constellation": "Sco",
    "ra_deg": 253.54499999999996,
    "dec_deg": -41.81194444444444,
    "ra_hms": "16:54:10.80",
    "dec_dms": "-41:48:43.0"
  },
  "NGC6240": {
    "id": "NGC6240",
    "name": "Starfish Galaxy",
    "type": "Seyfert 2 Galaxy",
    "constellation": "Oph",
    "ra_deg": 253.2454166666666,
    "dec_deg": 2.4008333333333334,
    "ra_hms": "16:52:58.90",
    "dec_dms": "+02:24:03.0"
  },
  "NGC6302": {
    "id": "NGC6302",
    "name": "Butterfly Nebula",
    "type": "Planetary Nebula",
    "constellation": "Sco",
    "ra_deg": 258.43541666666664,
    "dec_deg": -37.10305555555556,
    "ra_hms": "17:13:44.50",
    "dec_dms": "-37:06:11.0"
  },
  "NGC6334": {
    "id": "NGC6334",
    "name": "Cat's Paw Nebula",
    "type": "HII Region",
    "constellation": "Sco",
    "ra_deg": 259.97916666666663,
    "dec_deg": -35.833333333333336,
    "ra_hms": "17:19:55.00",
    "dec_dms": "-35:50:00.0"
  },
  "NGC6366": {
    "id": "NGC6366",
    "name": "NGC6366",
    "type": "Globular Cluster",
    "constellation": "Oph",
    "ra_deg": 261.9343333333333,
    "dec_deg": -5.079861111111111,
    "ra_hms": "17:27:44.24",
    "dec_dms": "-05:04:47.5"
  },
  "NGC6369": {
    "id": "NGC6369",
    "name": "Little Ghost Nebula",
    "type": "Planetary Nebula",
    "constellation": "Oph",
    "ra_deg": 262.33523604620996,
    "dec_deg": -23.75965883868,
    "ra_hms": "17:29:20.46",
    "dec_dms": "-23:45:34.8"
  },
  "NGC6397": {
    "id": "NGC6397",
    "name": "Caldwell 86",
    "type": "Globular Cluster",
    "constellation": "Ara",
    "ra_deg": 265.175375,
    "dec_deg": -53.67433333333333,
    "ra_hms": "17:40:42.09",
    "dec_dms": "-53:40:27.6"
  },
  "NGC6445": {
    "id": "NGC6445",
    "name": "Little Gem Nebula",
    "type": "Planetary Nebula",
    "constellation": "Sgr",
    "ra_deg": 267.31261766025455,
    "dec_deg": -20.00948878890889,
    "ra_hms": "17:49:15.03",
    "dec_dms": "-20:00:34.2"
  },
  "NGC6503": {
    "id": "NGC6503",
    "name": "NGC6503",
    "type": "Active Galactic Nuclei",
    "constellation": "Dra",
    "ra_deg": 267.36008658003,
    "dec_deg": 70.14433448116,
    "ra_hms": "17:49:26.42",
    "dec_dms": "+70:08:39.6"
  },
  "NGC6514": {
    "id": "NGC6514",
    "name": "Trifid Nebula",
    "type": "Open Cluster",
    "constellation": "Sgr",
    "ra_deg": 270.675,
    "dec_deg": -22.971666666666664,
    "ra_hms": "18:02:42.00",
    "dec_dms": "-22:58:18.0"
  },
  "NGC6541": {
    "id": "NGC6541",
    "name": "NGC6541",
    "type": "Globular Cluster",
    "constellation": "CrA",
    "ra_deg": 272.0098333333333,
    "dec_deg": -43.71488888888889,
    "ra_hms": "18:08:02.36",
    "dec_dms": "-43:42:53.6"
  },
  "NGC6559": {
    "id": "NGC6559",
    "name": "NGC6559",
    "type": "Nebula",
    "constellation": "Sgr",
    "ra_deg": 272.5,
    "dec_deg": -24.0,
    "ra_hms": "18:10:00.00",
    "dec_dms": "-24:00:00.0"
  },
  "NGC6712": {
    "id": "NGC6712",
    "name": "NGC6712",
    "type": "Globular Cluster",
    "constellation": "Sct",
    "ra_deg": 283.268,
    "dec_deg": -8.705972222222222,
    "ra_hms": "18:53:04.32",
    "dec_dms": "-08:42:21.5"
  },
  "NGC6723": {
    "id": "NGC6723",
    "name": "Chandelier Cluster",
    "type": "Globular Cluster",
    "constellation": "Sgr",
    "ra_deg": 284.888125,
    "dec_deg": -36.63225,
    "ra_hms": "18:59:33.15",
    "dec_dms": "-36:37:56.1"
  },
  "NGC6752": {
    "id": "NGC6752",
    "name": "Great Peacock Globular",
    "type": "Globular Cluster",
    "constellation": "Pav",
    "ra_deg": 287.717125,
    "dec_deg": -59.98455555555556,
    "ra_hms": "19:10:52.11",
    "dec_dms": "-59:59:04.4"
  },
  "NGC6760": {
    "id": "NGC6760",
    "name": "NGC6760",
    "type": "Globular Cluster",
    "constellation": "Aql",
    "ra_deg": 287.80025,
    "dec_deg": 1.0304722222222222,
    "ra_hms": "19:11:12.06",
    "dec_dms": "+01:01:49.7"
  },
  "NGC6781": {
    "id": "NGC6781",
    "name": "Snowglobe Nebula",
    "type": "Planetary Nebula",
    "constellation": "Aql",
    "ra_deg": 289.6170208333333,
    "dec_deg": 6.538691666666667,
    "ra_hms": "19:18:28.09",
    "dec_dms": "+06:32:19.3"
  },
  "NGC6819": {
    "id": "NGC6819",
    "name": "NGC6819",
    "type": "Open Cluster",
    "constellation": "Cyg",
    "ra_deg": 295.32708333333335,
    "dec_deg": 40.19,
    "ra_hms": "19:41:18.50",
    "dec_dms": "+40:11:24.0"
  },
  "NGC6888": {
    "id": "NGC6888",
    "name": "Crescent Nebula",
    "type": "Emission Nebula",
    "constellation": "Cyg",
    "ra_deg": 303.04999999999995,
    "dec_deg": 38.333333333333336,
    "ra_hms": "20:12:12.00",
    "dec_dms": "+38:20:00.0"
  },
  "NGC6934": {
    "id": "NGC6934",
    "name": "NGC6934",
    "type": "Globular Cluster",
    "constellation": "Del",
    "ra_deg": 308.54737499999993,
    "dec_deg": 7.404472222222223,
    "ra_hms": "20:34:11.37",
    "dec_dms": "+07:24:16.1"
  },
  "NGC7009": {
    "id": "NGC7009",
    "name": "Saturn Nebula",
    "type": "Planetary Nebula",
    "constellation": "Aqr",
    "ra_deg": 316.0450646615199,
    "dec_deg": -11.36349448821,
    "ra_hms": "21:04:10.82",
    "dec_dms": "-11:21:48.6"
  },
  "NGC7023": {
    "id": "NGC7023",
    "name": "Iris Nebula",
    "type": "Reflection Nebula",
    "constellation": "Cep",
    "ra_deg": 315.40374999999995,
    "dec_deg": 68.16333333333334,
    "ra_hms": "21:01:36.90",
    "dec_dms": "+68:09:48.0"
  },
  "NGC7027": {
    "id": "NGC7027",
    "name": "Jewel Bug Nebula",
    "type": "Planetary Nebula",
    "constellation": "Cyg",
    "ra_deg": 316.7565498,
    "dec_deg": 42.236242000000004,
    "ra_hms": "21:07:01.57",
    "dec_dms": "+42:14:10.5"
  },
  "NGC7293": {
    "id": "NGC7293",
    "name": "Helix Nebula",
    "type": "Planetary Nebula",
    "constellation": "Aqr",
    "ra_deg": 337.4106058529799,
    "dec_deg": -20.83715201178,
    "ra_hms": "22:29:38.55",
    "dec_dms": "-20:50:13.7"
  },
  "NGC7331": {
    "id": "NGC7331",
    "name": "NGC 7331 Group",
    "type": "Galaxy Group",
    "constellation": "Peg",
    "ra_deg": 339.26687751586996,
    "dec_deg": 34.415777799029996,
    "ra_hms": "22:37:04.05",
    "dec_dms": "+34:24:56.8"
  },
  "NGC7380": {
    "id": "NGC7380",
    "name": "NGC7380",
    "type": "Open Cluster",
    "constellation": "Cep",
    "ra_deg": 341.8170833333333,
    "dec_deg": 58.125,
    "ra_hms": "22:47:16.10",
    "dec_dms": "+58:07:30.0"
  },
  "NGC752": {
    "id": "NGC752",
    "name": "NGC752",
    "type": "Open Cluster",
    "constellation": "And",
    "ra_deg": 29.222916666666666,
    "dec_deg": 37.79388888888889,
    "ra_hms": "01:56:53.50",
    "dec_dms": "+37:47:38.0"
  },
  "NGC7635": {
    "id": "NGC7635",
    "name": "Bubble Nebula",
    "type": "HII Region",
    "constellation": "Cas",
    "ra_deg": 350.20124999999996,
    "dec_deg": 61.20166666666667,
    "ra_hms": "23:20:48.30",
    "dec_dms": "+61:12:06.0"
  },
  "NGC7662": {
    "id": "NGC7662",
    "name": "Blue Snowball",
    "type": "Planetary Nebula",
    "constellation": "And",
    "ra_deg": 351.4742994970104,
    "dec_deg": 42.53495439677222,
    "ra_hms": "23:25:53.83",
    "dec_dms": "+42:32:05.8"
  },
  "NGC7814": {
    "id": "NGC7814",
    "name": "NGC7814",
    "type": "Galaxy",
    "constellation": "Peg",
    "ra_deg": 0.8122791666666667,
    "dec_deg": 16.145227777777777,
    "ra_hms": "00:03:14.95",
    "dec_dms": "+16:08:42.8"
  },
  "SH2-136": {
    "id": "SH2-136",
    "name": "Ghost Nebula",
    "type": "Reflection Nebula",
    "constellation": "Cep",
    "ra_deg": 319.1083333333333,
    "dec_deg": 68.26,
    "ra_hms": "21:16:26.00",
    "dec_dms": "+68:15:36.0"
  },
  "SMC": {
    "id": "SMC",
    "name": "Small Magellanic Cloud",
    "type": "Galaxy",
    "constellation": "Tuc",
    "ra_deg": 13.158333333333331,
    "dec_deg": -72.80027777777778,
    "ra_hms": "00:52:38.00",
    "dec_dms": "-72:48:01.0"
  },
  "VIRGO_SUPERCLUSTER": {
    "id": "VIRGO_SUPERCLUSTER",
    "name": "Virgo Supercluster",
    "type": "Supercluster of Galaxies",
    "constellation": "Vir",
    "ra_deg": 187.75,
    "dec_deg": 12.4,
    "ra_hms": "12:31:00.00",
    "dec_dms": "+12:24:00.0"
  },
  "STEPHANS_QUINTET": {
    "id": "STEPHANS_QUINTET",
    "name": "Stephan's Quintet",
    "type": "Galaxy Group",
    "constellation": "Peg",
    "ra_deg": 339.623125,
    "dec_deg": 33.96055555555556,
    "ra_hms": "22:39:23.25",
    "dec_dms": "+33:57:38.0"
  },
  "MARKARIANS_CHAIN": {
    "id": "MARKARIANS_CHAIN",
    "name": "Markarian's Chain",
    "type": "Galaxy Chain",
    "constellation": "Vir",
    "ra_deg": 187.75,
    "dec_deg": 12.4,
    "ra_hms": "12:31:00.00",
    "dec_dms": "+12:24:00.0"
  },
  "MIZAR_AND_ALCOR": {
    "id": "MIZAR_AND_ALCOR",
    "name": "Mizar and Alcor",
    "type": "Double Star",
    "constellation": "UMa",
    "ra_deg": 13.4075, // Mizar
    "dec_deg": 54.92555555555555, // Mizar
    "ra_hms": "01:41:27.00", // Mizar
    "dec_dms": "+54:55:32.0" // Mizar
  },
};


// Helper function to get visible objects for a specific date
function getVisibleObjectsForDate(dateStr) {
  let date;
  if (dateStr) {
      date = new Date(dateStr);
  } else {
      date = new Date();
  }
  
  // Apply the 3-year modulo wrapping for years beyond 2027
  const year = date.getFullYear();
  if (year > 2027) {
      // Calculate which year in the 2025-2027 cycle to use
      const yearOffset = (year - 2025) % 3;
      const wrappedYear = 2025 + yearOffset;
      
      // Create a new date with the wrapped year but same month/day
      date = new Date(date);
      date.setFullYear(wrappedYear);
  }
  
  const formattedDate = date.toISOString().split('T')[0];
  const dayData = VISIBILITY_CALENDAR[formattedDate];

  if (!dayData) {
      return {
          date: formattedDate,
          north: null,
          south: null
      };
  }

  const northObject = dayData.north ? DSO_DETAILS[dayData.north] : null;
  const southObject = dayData.south ? DSO_DETAILS[dayData.south] : null;
  
  return {
      date: formattedDate,
      north: northObject,
      south: southObject
  };
}


// Function to convert object type code to full readable name
export function getObjectTypeName(typeCode) {
  const typeMap = {
    'G': 'Galaxy',
    'Rad': 'Radio Source',
    'OpC': 'Open Cluster',
    'GlC': 'Globular Cluster',
    'PN': 'Planetary Nebula',
    'HII': 'HII Region',
    'SNR': 'Supernova Remnant',
    'RNe': 'Reflection Nebula',
    'DNe': 'Dark Nebula',
    'LIN': 'LINER-type Active Galaxy',
    'SyG': 'Seyfert Galaxy',
    'X': 'X-ray Source',
    'gam': 'Gamma-ray Source',
    'GiP': 'Galaxy in Pair',
    'ClG': 'Cluster of Galaxies',
    'Sy2': 'Seyfert 2 Galaxy',
    'Cl*': 'Cluster of Stars',
    'rG': 'Radio Galaxy',
    'ISM': 'Interstellar Medium',
    '*': 'Star',
    'PN': 'Planetary Nebula',
    'UV': 'Ultraviolet Source'
  };

  return typeMap[typeCode] || typeCode;
}

// Function to convert constellation abbreviation to full name
export function getConstellationName(abbr) {
  const constellationMap = {
    'And': 'Andromeda',
    'Ant': 'Antlia',
    'Aps': 'Apus',
    'Aqr': 'Aquarius',
    'Aql': 'Aquila',
    'Ara': 'Ara',
    'Ari': 'Aries',
    'Aur': 'Auriga',
    'Boo': 'Boötes',
    'Cae': 'Caelum',
    'Cam': 'Camelopardalis',
    'Cnc': 'Cancer',
    'CVn': 'Canes Venatici',
    'CMa': 'Canis Major',
    'CMi': 'Canis Minor',
    'Cap': 'Capricornus',
    'Car': 'Carina',
    'Cas': 'Cassiopeia',
    'Cen': 'Centaurus',
    'Cep': 'Cepheus',
    'Cet': 'Cetus',
    'Cha': 'Chamaeleon',
    'Cir': 'Circinus',
    'Col': 'Columba',
    'Com': 'Coma Berenices',
    'CrA': 'Corona Australis',
    'CrB': 'Corona Borealis',
    'Crv': 'Corvus',
    'Crt': 'Crater',
    'Cru': 'Crux',
    'Cyg': 'Cygnus',
    'Del': 'Delphinus',
    'Dor': 'Dorado',
    'Dra': 'Draco',
    'Equ': 'Equuleus',
    'Eri': 'Eridanus',
    'For': 'Fornax',
    'Gem': 'Gemini',
    'Gru': 'Grus',
    'Her': 'Hercules',
    'Hor': 'Horologium',
    'Hya': 'Hydra',
    'Hyi': 'Hydrus',
    'Ind': 'Indus',
    'Lac': 'Lacerta',
    'Leo': 'Leo',
    'LMi': 'Leo Minor',
    'Lep': 'Lepus',
    'Lib': 'Libra',
    'Lup': 'Lupus',
    'Lyn': 'Lynx',
    'Lyr': 'Lyra',
    'Men': 'Mensa',
    'Mic': 'Microscopium',
    'Mon': 'Monoceros',
    'Mus': 'Musca',
    'Nor': 'Norma',
    'Oct': 'Octans',
    'Oph': 'Ophiuchus',
    'Ori': 'Orion',
    'Pav': 'Pavo',
    'Peg': 'Pegasus',
    'Per': 'Perseus',
    'Phe': 'Phoenix',
    'Pic': 'Pictor',
    'Psc': 'Pisces',
    'PsA': 'Piscis Austrinus',
    'Pup': 'Puppis',
    'Pyx': 'Pyxis',
    'Ret': 'Reticulum',
    'Sge': 'Sagitta',
    'Sgr': 'Sagittarius',
    'Sco': 'Scorpius',
    'Scl': 'Sculptor',
    'Sct': 'Scutum',
    'Ser': 'Serpens',
    'Sex': 'Sextans',
    'Tau': 'Taurus',
    'Tel': 'Telescopium',
    'Tri': 'Triangulum',
    'TrA': 'Triangulum Australe',
    'Tuc': 'Tucana',
    'UMa': 'Ursa Major',
    'UMi': 'Ursa Minor',
    'Vel': 'Vela',
    'Vir': 'Virgo',
    'Vol': 'Volans',
    'Vul': 'Vulpecula'
  };

  return constellationMap[abbr] || abbr;
}

export default getVisibleObjectsForDate;
